import React, { useState, useEffect, useRef } from 'react';
import Tesseract from 'tesseract.js';
import { GoogleGenerativeAI } from '@google/generative-ai';

import { useNavigate } from 'react-router-dom';
// استبدل سطر الـ imports الموجود بهذا:
import { 
    FileText, Users, CheckCircle2, Clock, AlertTriangle, 
    Phone, CreditCard, Settings, Plus, Edit3, Save, 
    Search, Filter, ArrowLeft, UserCheck, X, RefreshCw,
    DollarSign, Smartphone, Building, Wallet, Eye, Bell,
    Trash2, TrendingUp, TrendingDown, BarChart3, PieChart,
    Calculator, Receipt, ArrowUpCircle, ArrowDownCircle
} from 'lucide-react';
import config from '../config';


const VisaNetRegistration = () => {
    const navigate = useNavigate();
    
    // State Management
    const [confirmedPassports, setConfirmedPassports] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const isModalOpenRef = useRef(false); // أضف هذا السطر

    
    // UI State
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [selectedPassport, setSelectedPassport] = useState(null);
    
    // Modal States
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showNotesModal, setShowNotesModal] = useState(false);
 
    
    const [showPaymentMethodsModal, setShowPaymentMethodsModal] = useState(false);
    const [showNotificationsModal, setShowNotificationsModal] = useState(false);

const [showApplicationInfoModal, setShowApplicationInfoModal] = useState(false);
const [applicationInfoForm, setApplicationInfoForm] = useState({
    applicationNumber: '',
    fingerprintDate: ''
});

// إضافة هذه المتغيرات للـ State الموجود
const [wallets, setWallets] = useState([]);
const [financialTransactions, setFinancialTransactions] = useState([]);
const [financialStats, setFinancialStats] = useState({});
const [selectedWallet, setSelectedWallet] = useState(null);

// Modal States الجديدة
const [showAdvancedPaymentModal, setShowAdvancedPaymentModal] = useState(false);
const [showWalletManagementModal, setShowWalletManagementModal] = useState(false);
const [showInternalTransactionModal, setShowInternalTransactionModal] = useState(false);
const [showFinancialReportModal, setShowFinancialReportModal] = useState(false);

// Form States الجديدة
const [advancedPaymentForm, setAdvancedPaymentForm] = useState({
    baseAmount: 0,  // ← بدلاً من 3000
    discount: 0,
    additionalAmount: 0,
    walletId: '',
    paymentType: 'payment',
    notes: ''
});

const [newWalletForm, setNewWalletForm] = useState({
    name: '',
    currency: 'EGP', // EGP, SAR, USD
    balance: 0,
    type: 'cash'
});

const [internalTransactionForm, setInternalTransactionForm] = useState({
    walletId: '',
    amount: 0,
    transactionType: 'deposit', // deposit, withdraw
    description: ''
});


const [editingApplicationNumber, setEditingApplicationNumber] = useState(null);
const [editingFingerprintDate, setEditingFingerprintDate] = useState(null);
const [tempApplicationNumber, setTempApplicationNumber] = useState('');
const [tempFingerprintDate, setTempFingerprintDate] = useState('');

const [editingPassportNumber, setEditingPassportNumber] = useState(null);
const [tempPassportNumber, setTempPassportNumber] = useState('');


    const [showFullNotesModal, setShowFullNotesModal] = useState(false);
const [selectedNotesPassport, setSelectedNotesPassport] = useState(null);

const handleShowFullNotes = (passport) => {
    setSelectedNotesPassport(passport);
    setShowFullNotesModal(true);
};





const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [totalTransactions, setTotalTransactions] = useState(0);
const [hasMoreTransactions, setHasMoreTransactions] = useState(false);
const [transactionFilters, setTransactionFilters] = useState({
    startDate: '',
    endDate: '',
    walletId: ''
});



    const [notifications, setNotifications] = useState([]);
const [unreadCount, setUnreadCount] = useState(0);


    // Form States
const [paymentForm, setPaymentForm] = useState({
    baseAmount: 0,  // ← بدلاً من 3000
    discount: 0,
    additionalAmount: 0,
    paymentMethodId: '',
    notes: ''
});
    
    const [visaNotesForm, setVisaNotesForm] = useState('');
  
    const [newPaymentMethod, setNewPaymentMethod] = useState({
        name: '',
        type: 'cash', // cash, mobile, bank
        balance: 0
    });


    const [showRemoveModal, setShowRemoveModal] = useState(false);
const [removeReason, setRemoveReason] = useState('');





const [quickInputMode, setQuickInputMode] = useState(false);
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [additionalData, setAdditionalData] = useState({});
const [tempAdditionalData, setTempAdditionalData] = useState({});

    const [unsavedChanges, setUnsavedChanges] = useState(new Set());
    const [autoSaveStatus, setAutoSaveStatus] = useState({}); // 'saving', 'saved', 'error'
    
    // 🆕 نافذة البيانات الإضافية
    const [showAdditionalDataModal, setShowAdditionalDataModal] = useState(false);
    const [selectedPassportForAdditionalData, setSelectedPassportForAdditionalData] = useState(null);
    const [additionalDataForm, setAdditionalDataForm] = useState({
        visaNumber: '',
        employerNumber: '',
        detailedProfession: '',
        detailedCompanyName: ''
    });

    // 🆕 Functions للبيانات الإضافية
    
    // جلب البيانات الإضافية لشخص محدد
    const fetchAdditionalData = async (passportId) => {
        try {
            const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/additional-data/${passportId}`);
            const result = await response.json();
            
            if (result.success) {
                setAdditionalData(prev => ({
                    ...prev,
                    [passportId]: result.data || {}
                }));
                return result.data || {};
            }
        } catch (error) {
            console.error('خطأ في جلب البيانات الإضافية:', error);
        }
        return {};
    };

// دالة لحفظ البيانات يدوياً
// دالة لحفظ البيانات يدوياً
const saveAllAdditionalData = async (passportId) => {
    try {
        setIsLoading(true);
        console.log(`🔄 حفظ جميع البيانات الإضافية للجواز ${passportId}`);
        
        // جمع البيانات الحالية مع الجديدة
        const currentData = additionalData[passportId] || {};
        const tempData = tempAdditionalData[passportId] || {};
        
        // دمج البيانات القديمة مع الجديدة
        const finalData = {
            VisaNumber: tempData.VisaNumber !== undefined ? tempData.VisaNumber : currentData.VisaNumber || '',
            EmployerNumber: tempData.EmployerNumber !== undefined ? tempData.EmployerNumber : currentData.EmployerNumber || '',
            DetailedProfession: tempData.DetailedProfession !== undefined ? tempData.DetailedProfession : currentData.DetailedProfession || '',
            DetailedCompanyName: tempData.DetailedCompanyName !== undefined ? tempData.DetailedCompanyName : currentData.DetailedCompanyName || ''
        };
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/additional-data`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: parseInt(passportId),
                visaNumber: finalData.VisaNumber,
                employerNumber: finalData.EmployerNumber,
                detailedProfession: finalData.DetailedProfession,
                detailedCompanyName: finalData.DetailedCompanyName,
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            console.log('✅ تم حفظ جميع البيانات بنجاح');
            
            // تحديث البيانات المحفوظة بالبيانات النهائية
            setAdditionalData(prev => ({
                ...prev,
                [passportId]: finalData
            }));
            
            // مسح البيانات المؤقتة فقط للجواز ده
            setTempAdditionalData(prev => {
                const newData = { ...prev };
                delete newData[passportId];
                return newData;
            });
            
            showAlert('تم حفظ جميع البيانات بنجاح', 'success');
            
        } else {
            showAlert('فشل في الحفظ: ' + result.error, 'error');
        }
        
    } catch (error) {
        console.error('❌ خطأ في الحفظ:', error);
        showAlert('خطأ في الحفظ', 'error');
    } finally {
        setIsLoading(false);
    }
};

// دالة للحصول على القيمة (مؤقتة أو محفوظة)
// دالة للحصول على القيمة (مؤقتة أو محفوظة)
const getFieldValue = (passportId, fieldName) => {
    // لو فيه قيمة مؤقتة، استخدمها
    if (tempAdditionalData[passportId] && tempAdditionalData[passportId][fieldName] !== undefined) {
        return tempAdditionalData[passportId][fieldName];
    }
    
    // لو مفيش قيمة مؤقتة، استخدم المحفوظة
    return additionalData[passportId]?.[fieldName] || '';
};

// دالة لتحديث البيانات المؤقتة
// دالة لتحديث البيانات المؤقتة
// حدث دالة updateTempData لتكون أكثر كفاءة
const updateTempData = (passportId, fieldName, value) => {
    setTempAdditionalData(prev => ({
        ...prev,
        [passportId]: {
            ...prev[passportId],
            [fieldName]: value
        }
    }));
};

// دالة تبديل حالة الصف المتوسع
const toggleExpandedRow = (passportId) => {
    setExpandedRows(prev => {
        const newSet = new Set(prev);
        if (newSet.has(passportId)) {
            newSet.delete(passportId);
        } else {
            newSet.add(passportId);
            fetchAdditionalData(passportId);
        }
        return newSet;
    });
};

// دالة للتحقق من وجود تغييرات غير محفوظة
// دالة للتحقق من وجود تغييرات غير محفوظة
const hasUnsavedChanges = (passportId) => {
    const tempData = tempAdditionalData[passportId];
    if (!tempData) return false;
    
    // تحقق لو أي حقل اتغير
    const currentData = additionalData[passportId] || {};
    
    return Object.keys(tempData).some(fieldName => {
        return tempData[fieldName] !== (currentData[fieldName] || '');
    });
};

    // حفظ من النافذة المنبثقة
    const saveAdditionalDataModal = async () => {
        if (!selectedPassportForAdditionalData) return;

        try {
            setIsLoading(true);

            const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/additional-data`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    passportId: selectedPassportForAdditionalData.PassportID,
                    ...additionalDataForm,
                    updatedBy: 'قسم التأشيرات'
                })
            });

            const result = await response.json();

            if (result.success) {
                await fetchConfirmedPassports(); // تحديث البيانات
                setShowAdditionalDataModal(false);
                setAdditionalDataForm({
                    visaNumber: '',
                    employerNumber: '',
                    detailedProfession: '',
                    detailedCompanyName: ''
                });
                showAlert('تم حفظ البيانات الإضافية بنجاح', 'success');
            } else {
                showAlert('فشل في حفظ البيانات الإضافية', 'error');
            }

        } catch (error) {
            console.error('خطأ في حفظ البيانات الإضافية:', error);
            showAlert('خطأ في حفظ البيانات الإضافية', 'error');
        } finally {
            setIsLoading(false);
        }
    };


const ManualSaveInput = ({ value, onChange, placeholder, className = "" }) => {
    return (
        <input
            type="text"
            value={value}
            onChange={onChange}
            className={className}
            placeholder={placeholder}
        />
    );
};



const ExpandableRow = ({ passport }) => {
    const isExpanded = expandedRows.has(passport.PassportID);
    const passportAdditionalData = additionalData[passport.PassportID] || {};
    
    // 🔥 Local state للكتابة السلسة - مثل الوضع السريع
    const [localData, setLocalData] = useState({
        VisaNumber: '',
        EmployerNumber: '',
        DetailedProfession: '',
        DetailedCompanyName: ''
    });
    
    // تحميل البيانات عند فتح الصف
    useEffect(() => {
        if (isExpanded) {
            setLocalData({
                VisaNumber: passportAdditionalData.VisaNumber || '',
                EmployerNumber: passportAdditionalData.EmployerNumber || '',
                DetailedProfession: passportAdditionalData.DetailedProfession || '',
                DetailedCompanyName: passportAdditionalData.DetailedCompanyName || ''
            });
        }
    }, [isExpanded, passportAdditionalData]);
    
    // دالة التحديث المحلي - سريعة وسلسة
    const updateLocalData = (fieldName, value) => {
        setLocalData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
    
    // دالة الحفظ اليدوي
    const saveLocalData = async () => {
        try {
            setIsLoading(true);
            
            const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/additional-data`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    passportId: parseInt(passport.PassportID),
                    visaNumber: localData.VisaNumber,
                    employerNumber: localData.EmployerNumber,
                    detailedProfession: localData.DetailedProfession,
                    detailedCompanyName: localData.DetailedCompanyName,
                    updatedBy: 'قسم التأشيرات'
                })
            });
            
            const result = await response.json();
            
            if (result.success) {
                // تحديث البيانات الرئيسية
                setAdditionalData(prev => ({
                    ...prev,
                    [passport.PassportID]: localData
                }));
                
                showAlert('تم حفظ جميع البيانات بنجاح', 'success');
                
                // تحديث البيانات من السيرفر
                await fetchConfirmedPassports();
                
            } else {
                showAlert('فشل في الحفظ: ' + result.error, 'error');
            }
            
        } catch (error) {
            console.error('❌ خطأ في الحفظ:', error);
            showAlert('خطأ في الحفظ', 'error');
        } finally {
            setIsLoading(false);
        }
    };
    
    // التحقق من وجود تغييرات
    const hasLocalChanges = () => {
        return (
            localData.VisaNumber !== (passportAdditionalData.VisaNumber || '') ||
            localData.EmployerNumber !== (passportAdditionalData.EmployerNumber || '') ||
            localData.DetailedProfession !== (passportAdditionalData.DetailedProfession || '') ||
            localData.DetailedCompanyName !== (passportAdditionalData.DetailedCompanyName || '')
        );
    };

    return (
        <>
            {isExpanded && (
                <tr>
                    <td colSpan="16" className="px-0 py-0">
                        <div className="bg-gradient-to-r from-blue-50 to-purple-50 border-t border-b border-blue-200">
                            <div className="p-6">
                                <div className="mb-4">
                                    <h4 className="text-lg font-bold text-gray-800 mb-2 flex items-center gap-2">
                                        📋 البيانات التفصيلية - {passport.NameArabic}
                                    </h4>
                                    <div className="flex items-center gap-4 text-sm text-gray-600">
                                        <span>ID: {passport.PassportID}</span>
                                        <span>|</span>
                                        <span>نسبة الاكتمال: {passport.CompletionPercentage || 0}%</span>
                                        <div className="w-32 bg-gray-200 rounded-full h-2">
                                            <div 
                                                className="bg-blue-600 h-2 rounded-full transition-all duration-300" 
                                                style={{ width: `${passport.CompletionPercentage || 0}%` }}
                                            ></div>
                                        </div>
                                        {hasLocalChanges() && (
                                            <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs font-medium animate-pulse">
                                                تغييرات غير محفوظة
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* الحقول - بـ Local State سريع */}
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                    {/* رقم التأشيرة */}
                                    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            رقم التأشيرة
                                        </label>
                                        <input
                                            type="text"
                                            value={localData.VisaNumber}
                                            onChange={(e) => updateLocalData('VisaNumber', e.target.value)}
                                            placeholder="مثال: 1303938698"
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                                        />
                                    </div>

                                    {/* رقم صاحب العمل */}
                                    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            رقم صاحب العمل
                                        </label>
                                        <input
                                            type="text"
                                            value={localData.EmployerNumber}
                                            onChange={(e) => updateLocalData('EmployerNumber', e.target.value)}
                                            placeholder="مثال: 7012483983"
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                                        />
                                    </div>

                                    {/* المهنة التفصيلية */}
                                    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            المهنة التفصيلية
                                        </label>
                                        <input
                                            type="text"
                                            value={localData.DetailedProfession}
                                            onChange={(e) => updateLocalData('DetailedProfession', e.target.value)}
                                            placeholder="مهندس برمجيات..."
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                                        />
                                    </div>

                                    {/* الشركة التفصيلية */}
                                    <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            الشركة التفصيلية
                                        </label>
                                        <input
                                            type="text"
                                            value={localData.DetailedCompanyName}
                                            onChange={(e) => updateLocalData('DetailedCompanyName', e.target.value)}
                                            placeholder="شركة التقنية المتقدمة..."
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                                        />
                                    </div>
                                </div>

                                {/* نسبة الاكتمال */}
                                <div className="mt-4 bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        نسبة الاكتمال
                                    </label>
                                    <div className="flex items-center gap-3">
                                        <div className="flex-1 bg-gray-200 rounded-full h-3">
                                            <div 
                                                className={`h-3 rounded-full transition-all duration-300 ${
                                                    (passport.CompletionPercentage || 0) === 100 ? 'bg-green-500' :
                                                    (passport.CompletionPercentage || 0) >= 75 ? 'bg-blue-500' :
                                                    (passport.CompletionPercentage || 0) >= 50 ? 'bg-yellow-500' :
                                                    'bg-red-500'
                                                }`}
                                                style={{ width: `${passport.CompletionPercentage || 0}%` }}
                                            ></div>
                                        </div>
                                        <span className={`text-lg font-bold ${
                                            (passport.CompletionPercentage || 0) === 100 ? 'text-green-600' :
                                            (passport.CompletionPercentage || 0) >= 75 ? 'text-blue-600' :
                                            (passport.CompletionPercentage || 0) >= 50 ? 'text-yellow-600' :
                                            'text-red-600'
                                        }`}>
                                            {passport.CompletionPercentage || 0}%
                                        </span>
                                        <span className="text-sm text-gray-500">
                                            ({Math.round((passport.CompletionPercentage || 0) / 25)} من 4 حقول)
                                        </span>
                                    </div>
                                </div>

                                {/* أزرار الإجراءات */}
                                <div className="mt-6 flex gap-3 justify-center">
                                    {/* زر الحفظ - يظهر لو فيه تغييرات */}
                                    {hasLocalChanges() && (
                                        <button
                                            onClick={saveLocalData}
                                            disabled={isLoading}
                                            className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg transition-colors flex items-center gap-2 animate-pulse"
                                        >
                                            {isLoading ? (
                                                <RefreshCw className="animate-spin" size={20} />
                                            ) : (
                                                <Save size={20} />
                                            )}
                                            حفظ جميع التغييرات
                                        </button>
                                    )}

                                    {/* زر النافذة المنفصلة */}
                                    <button
                                        onClick={() => {
                                            setSelectedPassportForAdditionalData(passport);
                                            setAdditionalDataForm({
                                                visaNumber: localData.VisaNumber,
                                                employerNumber: localData.EmployerNumber,
                                                detailedProfession: localData.DetailedProfession,
                                                detailedCompanyName: localData.DetailedCompanyName
                                            });
                                            setShowAdditionalDataModal(true);
                                        }}
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg transition-colors flex items-center gap-2"
                                    >
                                        <Edit3 size={20} />
                                        تعديل في نافذة منفصلة
                                    </button>

                                    {/* زر نسخ البيانات */}
                                    <button
                                        onClick={() => {
                                            const data = `رقم التأشيرة: ${localData.VisaNumber || 'غير محدد'}\nرقم صاحب العمل: ${localData.EmployerNumber || 'غير محدد'}\nالمهنة: ${localData.DetailedProfession || 'غير محدد'}\nالشركة: ${localData.DetailedCompanyName || 'غير محدد'}`;
                                            navigator.clipboard.writeText(data);
                                            showAlert('تم نسخ البيانات', 'success');
                                        }}
                                        className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg transition-colors flex items-center gap-2"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                        </svg>
                                        نسخ البيانات
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
};









    // Alert System
const showAlert = (message, type = 'info') => {
    // منع إضافة alerts جديدة لو النافذة مفتوحة
    if (isModalOpenRef.current) {
        console.log('تم منع عرض التنبيه لأن النافذة مفتوحة:', message);
        return;
    }
    
    const id = Date.now();
    setAlerts(prev => [...prev, { id, message, type }]);
    
    setTimeout(() => {
        // فحص إضافي قبل حذف التنبيه
        if (!isModalOpenRef.current) {
            setAlerts(prev => prev.filter(alert => alert.id !== id));
        }
    }, 5000);
};


    const fetchNotifications = async () => {
      try {
          const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/notifications`);
          const data = await response.json();
          
          if (data.success) {
              setNotifications(data.notifications);
              setUnreadCount(data.notifications.filter(n => !n.IsRead).length);
          }
      } catch (error) {
          console.error('خطأ في جلب الإشعارات:', error);
      }
  };


  // ✅ أضف هذه الدالة بعد fetchNotifications
  const markAsRead = async (notificationId) => {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/notifications/${notificationId}/read`, {
            method: 'PUT'
        });
        
        if (response.ok) {
            fetchNotifications(); // تحديث القائمة
        }
    } catch (error) {
        console.error('خطأ في تمييز الإشعار كمقروء:', error);
    }
};


// مسح جميع الإشعارات
const clearAllNotifications = async () => {
    const confirmClear = window.confirm(
        '⚠️ تحذير: مسح جميع الإشعارات\n\nهل أنت متأكد من مسح جميع الإشعارات نهائياً؟\n\n🗑️ سيتم حذف جميع الإشعارات (المقروءة وغير المقروءة)\n\nهذا الإجراء لا يمكن التراجع عنه!'
    );
    
    if (!confirmClear) return;
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/notifications/clear-all`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                deletedBy: 'قسم التأشيرات - مسح يدوي'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            setNotifications([]);
            setUnreadCount(0);
            showAlert('تم مسح جميع الإشعارات بنجاح', 'success');
        } else {
            showAlert('فشل في مسح الإشعارات: ' + result.error, 'error');
        }
        
    } catch (error) {
        console.error('خطأ في مسح الإشعارات:', error);
        showAlert('خطأ في مسح الإشعارات', 'error');
    } finally {
        setIsLoading(false);
    }
};

// حذف إشعار محدد
const deleteNotification = async (notificationId) => {
    const confirmDelete = window.confirm('هل تريد حذف هذا الإشعار نهائياً؟');
    if (!confirmDelete) return;
    
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/notifications/${notificationId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                deletedBy: 'قسم التأشيرات'
            })
        });
        
        if (response.ok) {
            fetchNotifications(); // تحديث القائمة
            showAlert('تم حذف الإشعار بنجاح', 'success');
        }
    } catch (error) {
        console.error('خطأ في حذف الإشعار:', error);
        showAlert('خطأ في حذف الإشعار', 'error');
    }
};

// تشغيل التنظيف التلقائي (اختياري - للتأكد)
const triggerAutoCleanup = async () => {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/notifications/auto-cleanup`, {
            method: 'POST'
        });
        
        const result = await response.json();
        if (result.success && result.deletedCount > 0) {
            showAlert(`تم حذف ${result.deletedCount} إشعار قديم تلقائياً`, 'info');
            fetchNotifications();
        }
    } catch (error) {
        console.error('خطأ في التنظيف التلقائي:', error);
    }
};



// في بداية الكومبوننت، استبدل useEffect الموجود بهذا:
useEffect(() => {
    fetchConfirmedPassports();
    fetchWallets(); 
    fetchFinancialStats(); 
    fetchNotifications();
    
const interval = setInterval(() => {
    // استخدام الـ ref بدلاً من querySelector
    if (!isModalOpenRef.current) {
        fetchConfirmedPassports();
        fetchWallets(); 
    } else {
        console.log('تم منع التحديث التلقائي لأن النافذة مفتوحة');
    }
}, 30000);
    
const notificationInterval = setInterval(() => {
    if (!isModalOpenRef.current) {
        fetchNotifications();
    } else {
        console.log('تم منع تحديث الإشعارات لأن النافذة مفتوحة');
    }
}, 30000);
    
    return () => {
        clearInterval(interval);
        clearInterval(notificationInterval);
    };
}, []);



  // دالة تنظيف رقم الطلب من التكرار
const cleanDuplicatedApplicationNumber = (appNumber) => {
    if (!appNumber) return '';
    
    let cleaned = String(appNumber).replace(/[,\s]/g, '').trim();
    
    // إذا كان الرقم مكرر (نص طويل ومتشابه)
    if (cleaned.length > 8) {
        const half = Math.floor(cleaned.length / 2);
        const firstHalf = cleaned.substring(0, half);
        const secondHalf = cleaned.substring(half);
        
        // إذا كان النصفين متطابقين، خذ النصف الأول
        if (firstHalf === secondHalf) {
            return firstHalf;
        }
    }
    
    return cleaned;
};




// في الـ frontend، أضف تنظيف للبيانات عند جلبها
const fetchConfirmedPassports = async () => {
   try {
       const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/confirmed-passports`);
       const data = await response.json();
       
       if (data.success) {
           // تنظيف البيانات مع معالجة الأخطاء
           const cleanedPassports = data.passports.map(passport => {
               // تنظيف رقم الطلب من التكرار
               let cleanApplicationNumber = null;
               if (passport.ApplicationNumber) {
                   let appNum = String(passport.ApplicationNumber)
                       .replace(/,/g, '')
                       .replace(/\s+/g, '')
                       .trim();
                   
                   // إزالة التكرار في رقم الطلب
                   if (appNum.length > 10) {
                       const half = Math.floor(appNum.length / 2);
                       const firstHalf = appNum.substring(0, half);
                       const secondHalf = appNum.substring(half);
                       
                       if (firstHalf === secondHalf) {
                           appNum = firstHalf; // أخذ النصف الأول بس
                       }
                   }
                   
                   cleanApplicationNumber = appNum;
               }
               
               // تنظيف تاريخ البصمة - التعامل مع Array
               let cleanFingerprintDate = null;
               if (passport.FingerprintDate) {
                   try {
                       let dateValue = passport.FingerprintDate;
                       
                       // إذا كان Array، خذ أول قيمة صالحة
                       if (Array.isArray(dateValue)) {
                           console.log('تاريخ البصمة Array للجواز:', passport.PassportID, dateValue);
                           
                           // البحث عن أول تاريخ صالح في الـ Array
                           for (let i = 0; i < dateValue.length; i++) {
                               if (dateValue[i] && dateValue[i] !== null && dateValue[i] !== 'null') {
                                   dateValue = dateValue[i];
                                   break;
                               }
                           }
                           
                           // إذا كل العناصر null، اتركه null
                           if (!dateValue || dateValue === null || dateValue === 'null') {
                               dateValue = null;
                           }
                       }
                       
                       if (dateValue) {
                           const date = new Date(dateValue);
                           // التحقق من صحة التاريخ
                           if (!isNaN(date.getTime()) && date.getFullYear() > 1900 && date.getFullYear() < 2100) {
                               cleanFingerprintDate = date.toISOString().split('T')[0];
                               console.log('✅ تم تنظيف تاريخ البصمة:', passport.PassportID, cleanFingerprintDate);
                           } else {
                               console.warn('⚠️ تاريخ بصمة غير صحيح للجواز:', passport.PassportID, dateValue);
                           }
                       } else {
                           console.log('ℹ️ لا يوجد تاريخ بصمة للجواز:', passport.PassportID);
                       }
                   } catch (dateError) {
                       console.warn('❌ خطأ في تحويل تاريخ البصمة للجواز:', passport.PassportID, passport.FingerprintDate, dateError);
                   }
               }
               
               return {
                   ...passport,
                   ApplicationNumber: cleanApplicationNumber,
                   FingerprintDate: cleanFingerprintDate
               };
           });
           
           console.log('تم جلب وتنظيف البيانات بنجاح:', cleanedPassports.length, 'جواز');
           
           // حفظ البيانات الأساسية
           setConfirmedPassports(cleanedPassports);
           
           // 🆕 ملء بيانات الـ additionalData من النتائج
      const additionalDataMap = {};
cleanedPassports.forEach(passport => {
    // التحقق من وجود أي من البيانات الإضافية
    if (passport.VisaNumber || passport.EmployerNumber || passport.DetailedProfession || passport.DetailedCompanyName) {
        additionalDataMap[passport.PassportID] = {
            VisaNumber: passport.VisaNumber || '',
            EmployerNumber: passport.EmployerNumber || '',
            DetailedProfession: passport.DetailedProfession || '',
            DetailedCompanyName: passport.DetailedCompanyName || '',
            UpdatedAt: passport.AdditionalDataUpdatedAt || null
        };
    }
});

// دمج البيانات الجديدة مع الموجودة بدلاً من استبدالها
setAdditionalData(prev => ({
    ...prev,
    ...additionalDataMap
}));
           
           // تحديث البيانات الإضافية
           setAdditionalData(additionalDataMap);
           
           console.log('تم تحميل البيانات الإضافية لـ', Object.keys(additionalDataMap).length, 'شخص');
           
           // عرض نموذج من البيانات للفحص
           if (cleanedPassports.length > 0) {
               const firstPassport = cleanedPassports[0];
               console.log('نموذج بيانات منظف:', {
                   name: firstPassport.NameArabic,
                   id: firstPassport.PassportID,
                   applicationNumber: firstPassport.ApplicationNumber,
                   fingerprintDate: firstPassport.FingerprintDate,
                   visaNumber: firstPassport.VisaNumber,
                   employerNumber: firstPassport.EmployerNumber,
                   detailedProfession: firstPassport.DetailedProfession,
                   detailedCompanyName: firstPassport.DetailedCompanyName,
                   completionPercentage: firstPassport.CompletionPercentage,
                   originalApp: data.passports[0].ApplicationNumber,
                   originalDate: data.passports[0].FingerprintDate
               });
           }
           
       } else {
           console.error('فشل في جلب البيانات:', data.error);
           showAlert('خطأ في جلب البيانات: ' + data.error, 'error');
       }
   } catch (error) {
       console.error('خطأ في جلب الجوازات المؤكدة:', error);
       showAlert('خطأ في الاتصال بالخادم: ' + error.message, 'error');
   }
};

// أضف الدالة دي في بداية الكومبوننت
const isValidDate = (dateValue) => {
    if (!dateValue) return false;
    try {
        const date = new Date(dateValue);
        return !isNaN(date.getTime()) && 
               date.getFullYear() > 1900 && 
               date.getFullYear() < 2100;
    } catch {
        return false;
    }
};

// استخدمها في عرض التاريخ
const formatDate = (dateValue) => {
    if (!isValidDate(dateValue)) return 'تاريخ غير صحيح';
    
    try {
        const date = new Date(dateValue);
        return date.toLocaleDateString('ar-EG', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    } catch {
        return 'تاريخ غير صحيح';
    }
};

 

    // Update Final Status
 // تعديل دالة updateFinalStatus لحفظ/مسح تاريخ النت
const updateFinalStatus = async (passportId, status) => {
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/update-final-status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId,
                finalStatus: status,
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchConfirmedPassports();
            
            if (status === 'مكتمل') {
                showAlert(`تم تحديث الحالة إلى "${status}" وحفظ تاريخ النت`, 'success');
            } else {
                showAlert(`تم تحديث الحالة إلى "${status}" ومسح تاريخ النت`, 'success');
            }
        } else {
            showAlert('فشل في تحديث الحالة', 'error');
        }
    } catch (error) {
        console.error('خطأ في تحديث الحالة:', error);
        showAlert('خطأ في تحديث الحالة', 'error');
    } finally {
        setIsLoading(false);
    }
};

    // Add Visa Notes
    const addVisaNotes = async () => {
        if (!selectedPassport || !visaNotesForm.trim()) return;
        
        try {
            setIsLoading(true);
            
            const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/add-notes`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    passportId: selectedPassport.PassportID,
                    notes: visaNotesForm,
                    addedBy: 'قسم التأشيرات'
                })
            });
            
            const result = await response.json();
            
            if (result.success) {
                fetchConfirmedPassports();
                setShowNotesModal(false);
                setVisaNotesForm('');
                showAlert('تم إضافة الملاحظة بنجاح', 'success');
            } else {
                showAlert('فشل في إضافة الملاحظة', 'error');
            }
        } catch (error) {
            console.error('خطأ في إضافة الملاحظة:', error);
            showAlert('خطأ في إضافة الملاحظة', 'error');
        } finally {
            setIsLoading(false);
        }
    };



  

    // إضافة هذه الدوال بعد showAlert
const getCurrencySymbol = (currency) => {
    switch (currency) {
        case 'EGP': return 'ج.م';
        case 'SAR': return 'ر.س';
        case 'USD': return '$';
        default: return currency;
    }
};

const getCurrencyName = (currency) => {
    switch (currency) {
        case 'EGP': return 'جنيه مصري';
        case 'SAR': return 'ريال سعودي';
        case 'USD': return 'دولار أمريكي';
        default: return currency;
    }
};

// إضافة هذه الدوال بعد fetchPaymentMethods
const fetchWallets = async () => {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/wallets`);
        const data = await response.json();
        
        if (data.success) {
            setWallets(data.wallets);
        }
    } catch (error) {
        console.error('خطأ في جلب المحافظ:', error);
    }
};



const fetchFinancialTransactions = async (filters = {}, page = 1, append = false) => {
    try {
        const params = new URLSearchParams({
            page: page,
            limit: 20,
            ...transactionFilters,
            ...filters
        });
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/financial-transactions?${params}`);
        const data = await response.json();
        
        if (data.success) {
            if (append) {
                // إضافة المعاملات الجديدة للموجودة
                setFinancialTransactions(prev => [...prev, ...data.transactions]);
            } else {
                // استبدال المعاملات
                setFinancialTransactions(data.transactions);
            }
            
            setCurrentPage(data.pagination.currentPage);
            setTotalPages(data.pagination.totalPages);
            setTotalTransactions(data.pagination.totalCount);
            setHasMoreTransactions(data.pagination.hasMore);
            
            console.log(`📊 ${data.pagination.showing} معاملة`);
        }
    } catch (error) {
        console.error('خطأ في جلب المعاملات المالية:', error);
    }
};



const fetchFinancialStats = async () => {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/financial-statistics`);
        const data = await response.json();
        
        if (data.success) {
            setFinancialStats(data.statistics);
        }
    } catch (error) {
        console.error('خطأ في جلب الإحصائيات المالية:', error);
    }
};
    // Add Payment Method
   



    // إضافة هذه الدوال بعد addPaymentMethod
const addWallet = async () => {
    if (!newWalletForm.name.trim()) {
        showAlert('يرجى إدخال اسم المحفظة', 'warning');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/wallets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newWalletForm)
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchWallets();
            setNewWalletForm({
                name: '',
                currency: 'EGP',
                balance: 0,
                type: 'cash'
            });
            showAlert('تم إضافة المحفظة بنجاح', 'success');
        } else {
            showAlert('فشل في إضافة المحفظة', 'error');
        }
    } catch (error) {
        console.error('خطأ في إضافة المحفظة:', error);
        showAlert('خطأ في إضافة المحفظة', 'error');
    } finally {
        setIsLoading(false);
    }
};

const processInternalTransaction = async () => {
    if (!internalTransactionForm.walletId || !internalTransactionForm.amount || !internalTransactionForm.description.trim()) {
        showAlert('يرجى ملء جميع الحقول المطلوبة', 'warning');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/internal-transaction`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...internalTransactionForm,
                processedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchWallets();
            fetchFinancialTransactions();
            fetchFinancialStats();
            setShowInternalTransactionModal(false);
            setInternalTransactionForm({
                walletId: '',
                amount: 0,
                transactionType: 'deposit',
                description: ''
            });
            showAlert(result.message, 'success');
        } else {
            showAlert('فشل في المعاملة: ' + result.message, 'error');
        }
    } catch (error) {
        console.error('خطأ في المعاملة الداخلية:', error);
        showAlert('خطأ في المعاملة الداخلية', 'error');
    } finally {
        setIsLoading(false);
    }
};







const processAdvancedPayment = async () => {
    if (!selectedPassport || !advancedPaymentForm.walletId) {
        showAlert('يرجى اختيار المحفظة', 'warning');
        return;
    }
    
    const totalAmount = advancedPaymentForm.baseAmount - advancedPaymentForm.discount + advancedPaymentForm.additionalAmount;
    
    if (totalAmount <= 0 && advancedPaymentForm.paymentType === 'payment') {
        showAlert('المبلغ الإجمالي يجب أن يكون أكبر من صفر', 'warning');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/advanced-payment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: selectedPassport.PassportID,
                baseAmount: advancedPaymentForm.baseAmount,
                discount: advancedPaymentForm.discount,
                additionalAmount: advancedPaymentForm.additionalAmount,
                totalAmount: totalAmount,
                walletId: advancedPaymentForm.walletId,
                paymentType: advancedPaymentForm.paymentType,
                notes: advancedPaymentForm.notes,
                processedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchConfirmedPassports();
            fetchWallets();
            fetchFinancialTransactions();
            fetchFinancialStats();
            setShowAdvancedPaymentModal(false);
       setAdvancedPaymentForm({
    baseAmount: 0,  // ← بدلاً من 3000
    discount: 0,
    additionalAmount: 0,
    walletId: '',
    paymentType: 'payment',
    notes: ''
});
            showAlert(result.message, 'success');
        } else {
            showAlert('فشل في العملية: ' + result.message, 'error');
        }
    } catch (error) {
        console.error('خطأ في العملية المالية:', error);
        showAlert('خطأ في العملية المالية', 'error');
    } finally {
        setIsLoading(false);
    }
};




// حذف محفظة
const deleteWallet = async (walletId, walletName) => {
    const confirmDelete = window.confirm(
        `هل أنت متأكد من حذف محفظة "${walletName}"؟\n\n⚠️ إذا كانت هناك معاملات مرتبطة بها، سيتم إلغاء تفعيلها فقط.`
    );
    
    if (!confirmDelete) return;
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/wallets/${walletId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                deletedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchWallets();
            fetchFinancialStats();
            showAlert(result.message, 'success');
        } else {
            showAlert('فشل في حذف المحفظة: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في حذف المحفظة:', error);
        showAlert('خطأ في حذف المحفظة', 'error');
    } finally {
        setIsLoading(false);
    }
};

// حذف معاملة
// حذف معاملة
const deleteTransaction = async (transactionId, description) => {
    const confirmDelete = window.confirm(
        `⚠️ تحذير: حذف المعاملة\n\nهل أنت متأكد من حذف هذه المعاملة نهائياً؟\n\n"${description}"\n\n⚠️ سيتم استرداد المبلغ للمحفظة وتحديث حالة الدفع.\n\nهذا الإجراء لا يمكن التراجع عنه!`
    );
    
    if (!confirmDelete) return;

    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/financial-transactions/${transactionId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                deletedBy: 'قسم التأشيرات',
                reason: 'حذف بدون ذكر سبب' // سبب افتراضي
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchFinancialTransactions();
            fetchWallets();
            fetchFinancialStats();
            showAlert('تم حذف المعاملة نهائياً وإرجاع المبلغ للمحفظة', 'success');
        } else {
            showAlert('فشل في حذف المعاملة: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في حذف المعاملة:', error);
        showAlert('خطأ في حذف المعاملة', 'error');
    } finally {
        setIsLoading(false);
    }
};

// تعديل معاملة
const editTransaction = async (transaction) => {
    const newAmount = prompt(`تعديل المبلغ:\nالمبلغ الحالي: ${Math.abs(transaction.Amount)}\n\nأدخل المبلغ الجديد:`, Math.abs(transaction.Amount));
    if (!newAmount || isNaN(newAmount)) return;
    
    const newDescription = prompt(`تعديل الوصف:\nالوصف الحالي: ${transaction.Description}\n\nأدخل الوصف الجديد:`, transaction.Description);
    if (!newDescription) return;
    
    const newNotes = prompt(`ملاحظات إضافية (اختياري):`, transaction.Notes || '');
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/financial-transactions/${transaction.TransactionID}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                amount: parseFloat(newAmount),
                description: newDescription,
                notes: newNotes,
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchFinancialTransactions();
            fetchWallets();
            fetchFinancialStats();
            showAlert(result.message, 'success');
        } else {
            showAlert('فشل في تعديل المعاملة: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في تعديل المعاملة:', error);
        showAlert('خطأ في تعديل المعاملة', 'error');
    } finally {
        setIsLoading(false);
    }
};



    const savePassportNumber = async (passportId) => {
    if (!tempPassportNumber.trim()) {
        showAlert('يرجى إدخال رقم الجواز', 'warning');
        return;
    }
    
    // التحقق من صحة رقم الجواز
    if (!/^[A][0-9]{8}$/.test(tempPassportNumber.trim())) {
        showAlert('رقم الجواز يجب أن يبدأ بحرف A متبوعاً بـ 8 أرقام', 'error');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/update-passport-number`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: passportId,
                passportNumber: tempPassportNumber.trim().toUpperCase(),
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            await fetchConfirmedPassports();
            setEditingPassportNumber(null);
            setTempPassportNumber('');
            showAlert('تم تحديث رقم الجواز بنجاح', 'success');
        } else {
            showAlert('فشل في تحديث رقم الجواز: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في تحديث رقم الجواز:', error);
        showAlert('خطأ في تحديث رقم الجواز', 'error');
    } finally {
        setIsLoading(false);
    }
};

// دالة إلغاء التعديل لرقم الجواز
const cancelPassportNumberEdit = () => {
    setEditingPassportNumber(null);
    setTempPassportNumber('');
};



const removeFromVisaList = async () => {
    if (!selectedPassport) {
        showAlert('حدث خطأ، يرجى المحاولة مرة أخرى', 'error');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/remove-from-visa-list`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: selectedPassport.PassportID,
                reason: removeReason.trim() || null, // إرسال null إذا كان فارغ
                removedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchConfirmedPassports();
            setShowRemoveModal(false);
            setRemoveReason('');
            
            const message = result.hasReason 
                ? `تم إلغاء تأكيد "${result.personInfo.name}" مع إضافة ملاحظة الإلغاء`
                : `تم إلغاء تأكيد "${result.personInfo.name}" بدون ملاحظة`;
                
            showAlert(message, 'success');
        } else {
            showAlert('فشل في إلغاء التأكيد: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في إلغاء التأكيد:', error);
        showAlert('خطأ في إلغاء التأكيد', 'error');
    } finally {
        setIsLoading(false);
    }
};





    // Filter Functions
    const getFilteredPassports = () => {
        let filtered = confirmedPassports;
        
        if (statusFilter !== 'all') {
            filtered = filtered.filter(p => {
                if (statusFilter === 'pending') return !p.FinalStatus || p.FinalStatus === 'في الانتظار';
                if (statusFilter === 'completed') return p.FinalStatus === 'مكتمل';
                if (statusFilter === 'paid') return p.PaymentStatus === 'مدفوع';
                if (statusFilter === 'unpaid') return !p.PaymentStatus || p.PaymentStatus === 'غير مدفوع';
                return true;
            });
        }
        
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(p => 
                p.NameArabic?.toLowerCase().includes(term) ||
                p.PassportNumber?.toLowerCase().includes(term) ||
                p.CompanyName?.toLowerCase().includes(term) ||
                p.DelegateName?.toLowerCase().includes(term) ||
                p.PhoneNumbers?.toLowerCase().includes(term)
            );
        }
        
        return filtered;
    };

const getStatusColor = (status) => {
    switch (status) {
        case 'مكتمل': return 'bg-green-50 text-green-700';
        case 'جاري العمل': return 'bg-blue-50 text-blue-700';
        case 'مؤجل': return 'bg-orange-50 text-orange-700';
        case 'ملغي': return 'bg-red-50 text-red-700';
        case '': return 'bg-gray-50 text-gray-600'; 
        default: return 'bg-gray-50 text-gray-700';
    }
};

// استبدال دالة getPaymentStatusColor الموجودة بهذه النسخة المحدثة:
const getPaymentStatusColor = (status) => {
    switch (status) {
        case 'مدفوع': return 'bg-green-50 text-green-700 border border-green-200';
        case 'غير مدفوع': return 'bg-red-50 text-red-700 border border-red-200';
        case 'مسترد': return 'bg-orange-50 text-orange-700 border border-orange-200';
        case 'ملغي': return 'bg-gray-50 text-gray-700 border border-gray-200';
        case 'دفع جزئي': return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
        default: return 'bg-gray-50 text-gray-700 border border-gray-200';
    }
};

    
// في ملف VisaNetRegistration.js - استبدل الدوال الموجودة بهذه النسخ المحسنة

// ✅ دالة معالجة أرقام الهواتف المحسنة - نفس المنطق من صفحة الاختيار
const getPhoneNumber = (phoneNumbers) => {
    if (!phoneNumbers) return '';
    
    try {
        if (typeof phoneNumbers === 'string') {
            if (phoneNumbers.startsWith('[')) {
                const parsed = JSON.parse(phoneNumbers);
                return Array.isArray(parsed) ? (parsed[0] || '') : phoneNumbers;
            }
            return phoneNumbers;
        } else if (Array.isArray(phoneNumbers)) {
            return phoneNumbers[0] || '';
        }
        return phoneNumbers.toString();
    } catch (error) {
        return phoneNumbers || '';
    }
};

// في VisaNetRegistration.js، أضف هذه الدالة مع باقي الدوال:

// في VisaNetRegistration.js، تحسين دالة handleDeleteVisaNote:

// في VisaNetRegistration.js، استبدل دالة handleDeleteVisaNote بهذه النسخة المُصححة:

const handleDeleteVisaNote = async (passportId, noteToDelete, noteIndex) => {
    // تأكيد الحذف
    const confirmDelete = window.confirm(
        `هل أنت متأكد من حذف هذه الملاحظة نهائياً؟\n\n"${noteToDelete}"\n\n⚠️ سيتم حذفها من كلا النظامين ولن يمكن استرجاعها.`
    );
    
    if (!confirmDelete) return;

    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/delete-visa-note`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: passportId,
                noteToDelete: noteToDelete,
                noteIndex: noteIndex,
                deletedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            showAlert('تم حذف الملاحظة نهائياً من النظامين', 'success');
            
            // تحديث البيانات
            await fetchConfirmedPassports();
            
            // تحديث النافذة المنبثقة - البحث في البيانات المحدثة
            setTimeout(() => {
                const updatedPassport = confirmedPassports.find(p => p.PassportID === passportId);
                if (updatedPassport) {
                    setSelectedNotesPassport(updatedPassport);
                }
            }, 1000); // انتظار ثانية واحدة للتأكد من تحديث البيانات
            
        } else {
            showAlert('فشل في حذف الملاحظة: ' + result.message, 'error');
        }
    } catch (error) {
        console.error('خطأ في حذف الملاحظة:', error);
        showAlert('خطأ في حذف الملاحظة', 'error');
    } finally {
        setIsLoading(false);
    }
};


// استبدل دالة saveApplicationNumber بالكود ده
const saveApplicationNumber = async (passportId) => {
    if (!tempApplicationNumber.trim()) {
        showAlert('يرجى إدخال رقم الطلب', 'warning');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/update-application-info`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: passportId,
                applicationNumber: tempApplicationNumber.trim(), // إزالة المسافات
                fingerprintDate: null, // مش هنحدث تاريخ البصمة هنا
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            await fetchConfirmedPassports(); // انتظار تحديث البيانات
            setEditingApplicationNumber(null);
            setTempApplicationNumber('');
            showAlert('تم تحديث رقم الطلب بنجاح', 'success');
        } else {
            showAlert('فشل في تحديث رقم الطلب: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في تحديث رقم الطلب:', error);
        showAlert('خطأ في تحديث رقم الطلب', 'error');
    } finally {
        setIsLoading(false);
    }
};

// استبدل دالة saveFingerprintDate بالكود ده
const saveFingerprintDate = async (passportId) => {
    if (!tempFingerprintDate) {
        showAlert('يرجى اختيار تاريخ البصمة', 'warning');
        return;
    }
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/update-application-info`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: passportId,
                applicationNumber: null, // مش هنحدث رقم الطلب هنا
                fingerprintDate: tempFingerprintDate, // التاريخ بصيغة YYYY-MM-DD
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            await fetchConfirmedPassports(); // انتظار تحديث البيانات
            setEditingFingerprintDate(null);
            setTempFingerprintDate('');
            showAlert('تم تحديث تاريخ البصمة بنجاح', 'success');
        } else {
            showAlert('فشل في تحديث تاريخ البصمة: ' + result.error, 'error');
        }
    } catch (error) {
        console.error('خطأ في تحديث تاريخ البصمة:', error);
        showAlert('خطأ في تحديث تاريخ البصمة', 'error');
    } finally {
        setIsLoading(false);
    }
};



// دالة إلغاء التعديل
const cancelEdit = (type) => {
    if (type === 'application') {
        setEditingApplicationNumber(null);
        setTempApplicationNumber('');
    } else if (type === 'fingerprint') {
        setEditingFingerprintDate(null);
        setTempFingerprintDate('');
    }
};


const updateApplicationInfo = async () => {
    if (!selectedPassport) return;
    
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/update-application-info`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: selectedPassport.PassportID,
                applicationNumber: applicationInfoForm.applicationNumber,
                fingerprintDate: applicationInfoForm.fingerprintDate,
                updatedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            fetchConfirmedPassports();
            setShowApplicationInfoModal(false);
            setApplicationInfoForm({ applicationNumber: '', fingerprintDate: '' });
            showAlert('تم تحديث رقم الطلب وتاريخ البصمة بنجاح', 'success');
        } else {
            showAlert('فشل في تحديث البيانات', 'error');
        }
    } catch (error) {
        console.error('خطأ في تحديث رقم الطلب وتاريخ البصمة:', error);
        showAlert('خطأ في تحديث البيانات', 'error');
    } finally {
        setIsLoading(false);
    }
};

// في VisaNetRegistration.js، استبدل دالة getNotesText بهذه النسخة المحسنة:

const getNotesText = (notes) => {
    if (!notes) return '';
    
    try {
        // إذا كان النص بسيط بدون رموز JSON
        if (typeof notes === 'string' && !notes.includes('{') && !notes.includes('[') && !notes.includes('"')) {
            return notes.trim();
        }
        
        // إذا كان array بسيط
        if (Array.isArray(notes)) {
            return notes
                .filter(note => note && (note.text || typeof note === 'string'))
                .map(note => {
                    if (typeof note === 'string') return note.trim();
                    if (note.text) return note.text.trim();
                    return '';
                })
                .filter(text => text.length > 0)
                .join('\n');
        }
        
        // إذا كان object بسيط
        if (typeof notes === 'object' && notes.text) {
            return notes.text.trim();
        }
        
        // معالجة النصوص التي تحتوي على JSON
        if (typeof notes === 'string') {
            // تنظيف النص أولاً
            let cleanText = notes.trim();
            
            // إذا كان يبدأ بـ [ أو {، حاول معالجته كـ JSON
            if (cleanText.startsWith('[') || cleanText.startsWith('{')) {
                try {
                    // تنظيف JSON معطوب - إزالة الأحرف الغريبة
                    cleanText = cleanText
                        .replace(/[\u0000-\u001F\u007F-\u009F]/g, '') // إزالة control characters
                        .replace(/\n|\r/g, ' ') // استبدال الأسطر الجديدة بمسافات
                        .replace(/\s+/g, ' ') // تنظيف المسافات المتعددة
                        .trim();
                    
                    // محاولة إصلاح JSON معطوب
                    if (cleanText.startsWith('[') && !cleanText.endsWith(']')) {
                        // البحث عن آخر } وإضافة ]
                        const lastBraceIndex = cleanText.lastIndexOf('}');
                        if (lastBraceIndex !== -1) {
                            cleanText = cleanText.substring(0, lastBraceIndex + 1) + ']';
                        } else {
                            // إذا لم توجد }، أزل [ من البداية
                            cleanText = cleanText.substring(1);
                        }
                    }
                    
                    // محاولة تحليل JSON
                    const parsed = JSON.parse(cleanText);
                    
                    if (Array.isArray(parsed)) {
                        return parsed
                            .filter(note => note && (note.text || typeof note === 'string'))
                            .map(note => {
                                if (typeof note === 'string') return note.trim();
                                if (note.text) return note.text.trim();
                                return '';
                            })
                            .filter(text => text.length > 0)
                            .join('\n');
                    } else if (parsed.text) {
                        return parsed.text.trim();
                    } else {
                        return String(parsed).trim();
                    }
                } catch (jsonError) {
                    console.warn('فشل في تحليل JSON للملاحظات، سيتم استخدام النص كما هو:', jsonError);
                    
                    // كخطة بديلة، قم بتنظيف النص وإرجاعه
                    return cleanText
                        .replace(/^\[|\]$/g, '') // إزالة أقواس مربعة
                        .replace(/^\{|\}$/g, '') // إزالة أقواس مجعدة
                        .replace(/["{}[\],]/g, ' ') // إزالة رموز JSON
                        .replace(/\s+/g, ' ') // تنظيف المسافات
                        .replace(/text:|id:|date:|user:|type:/g, '') // إزالة مفاتيح JSON
                        .trim();
                }
            } else {
                // نص عادي
                return cleanText;
            }
        }
        
        // أي حالة أخرى
        return String(notes || '').trim();
        
    } catch (error) {
        console.error('خطأ عام في معالجة الملاحظات:', error);
        
        // كحل أخير، ارجع النص مُنظف
        return String(notes || '')
            .replace(/[{}[\]"]/g, '') // إزالة رموز JSON
            .replace(/\s+/g, ' ') // تنظيف المسافات
            .replace(/text:|id:|date:|user:|type:/g, '') // إزالة مفاتيح JSON شائعة
            .trim();
    }
};






// في VisaNetRegistration.js، أضف هذه الدالة المساعدة:

const safeJsonParse = (jsonString) => {
    if (!jsonString || typeof jsonString !== 'string') {
        return null;
    }
    
    try {
        // تنظيف أولي
        let cleaned = jsonString
            .replace(/[\u0000-\u001F\u007F-\u009F]/g, '') // إزالة control characters
            .replace(/\n|\r/g, ' ') // استبدال الأسطر الجديدة
            .replace(/\s+/g, ' ') // تنظيف المسافات المتعددة
            .trim();
        
        // محاولة تحليل JSON
        return JSON.parse(cleaned);
    } catch (error) {
        // محاولة إصلاح JSON معطوب
        try {
            let fixed = jsonString.trim();
            
            // إصلاح الأقواس المفقودة
            if (fixed.startsWith('[') && !fixed.endsWith(']')) {
                const lastBrace = fixed.lastIndexOf('}');
                if (lastBrace !== -1) {
                    fixed = fixed.substring(0, lastBrace + 1) + ']';
                }
            }
            
            if (fixed.startsWith('{') && !fixed.endsWith('}')) {
                fixed += '}';
            }
            
            return JSON.parse(fixed);
        } catch (fixError) {
            console.warn('فشل في إصلاح JSON:', fixError);
            return null;
        }
    }
};

// ✅ دالة عرض الهواتف المدمجة محسنة
// في VisaNetRegistration.js، استبدل دالة getCombinedPhones بهذه النسخة المحسنة:





// في VisaNetRegistration.js، استبدل دالة getCombinedPhones بهذه النسخة المحسنة:

const getCombinedPhones = (combinedPhones) => {
    if (!combinedPhones) return '';
    
    try {
        if (typeof combinedPhones === 'string') {
            const parts = combinedPhones.split(' | إضافي: ');
            if (parts.length > 1) {
                const originalPhones = getPhoneNumbers(parts[0]);
                const additionalPhones = getPhoneNumbers(parts[1]);
                
                return (
                    <div className="space-y-2">
                        {/* الأرقام الأساسية */}
                        {originalPhones.length > 0 && originalPhones.map((phone, index) => (
                            <div key={`original-${index}`} className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                                <span className="text-gray-800 font-medium bg-green-50 px-3 py-1 rounded-full text-sm border border-green-200">
                                    📞 {phone}
                                </span>
                                {index === 0 && (
                                    <span className="bg-green-100 text-green-600 px-2 py-0.5 rounded-full text-xs font-medium">
                                        أساسي
                                    </span>
                                )}
                            </div>
                        ))}
                        
                        {/* الأرقام الإضافية */}
                        {additionalPhones.length > 0 && additionalPhones.map((phone, index) => (
                            <div key={`additional-${index}`} className="flex items-center gap-2 group">
                                <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
                                <span className="text-blue-600 font-medium bg-blue-50 px-3 py-1 rounded-full text-sm border border-blue-200">
                                    📱 {phone}
                                </span>
                                <span className="bg-orange-100 text-orange-600 px-2 py-0.5 rounded-full text-xs font-medium">
                                    إضافي
                                </span>
                                {/* زر الحذف للأرقام الإضافية */}
                                <button
                                    onClick={() => handleDeletePhone(selectedPassport?.PassportID, phone)}
                                    className="opacity-0 group-hover:opacity-100 bg-red-100 hover:bg-red-200 text-red-600 p-1 rounded-full transition-all duration-200 hover:scale-110"
                                    title="حذف هذا الرقم"
                                >
                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        ))}
                    </div>
                );
            }
            
            // رقم واحد فقط
            const phones = getPhoneNumbers(combinedPhones);
            return (
                <div className="space-y-1">
                    {phones.map((phone, index) => (
                        <div key={`single-${index}`} className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                            <span className="text-gray-800 font-medium bg-green-50 px-3 py-1 rounded-full text-sm border border-green-200">
                                📞 {phone}
                            </span>
                        </div>
                    ))}
                </div>
            );
        }
        return getPhoneNumbers(combinedPhones.toString());
    } catch (error) {
        return getPhoneNumbers(combinedPhones || '');
    }
};

// دالة مساعدة لاستخراج أرقام الهواتف
const getPhoneNumbers = (phoneString) => {
    if (!phoneString) return [];
    
    try {
        // إذا كان JSON array
        if (phoneString.startsWith('[')) {
            const parsed = JSON.parse(phoneString);
            return Array.isArray(parsed) ? parsed.filter(phone => phone && phone.trim()) : [];
        }
        
        // إذا كان نص عادي مفصول بفواصل
        return phoneString.split(',').map(phone => phone.trim()).filter(phone => phone);
    } catch (error) {
        // إذا فشل، قسم بالفواصل
        return phoneString.split(',').map(phone => phone.trim()).filter(phone => phone);
    }
};




// في VisaNetRegistration.js، أضف هذه الدالة:

const handleDeletePhone = async (passportId, phoneToDelete) => {
    // تأكيد الحذف
    const confirmDelete = window.confirm(
        `هل أنت متأكد من حذف رقم الهاتف؟\n\n📱 ${phoneToDelete}\n\n⚠️ سيتم حذفه نهائياً من النظامين.`
    );
    
    if (!confirmDelete) return;

    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/delete-phone`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: passportId,
                phoneToDelete: phoneToDelete,
                deletedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            showAlert('تم حذف رقم الهاتف نهائياً', 'success');
            
            // تحديث البيانات
            await fetchConfirmedPassports();
            
        } else {
            showAlert('فشل في حذف رقم الهاتف: ' + result.message, 'error');
        }
    } catch (error) {
        console.error('خطأ في حذف رقم الهاتف:', error);
        showAlert('خطأ في حذف رقم الهاتف', 'error');
    } finally {
        setIsLoading(false);
    }
};
// في VisaNetRegistration.js، أضف هذه الدالة المساعدة:


const ImageViewer = ({ src, alt, type, personName }) => {
    const [showModal, setShowModal] = useState(false);
    const [extractedText, setExtractedText] = useState('');
    const [isExtracting, setIsExtracting] = useState(false);
    const [showTextPanel, setShowTextPanel] = useState(false);
    useEffect(() => {
    isModalOpenRef.current = showModal;
}, [showModal]);
    
    // ضع مفتاح Gemini API هنا مباشرة
    const GEMINI_API_KEY = "REMOVED_GOOGLE_API_KEY"; // استبدل هذا بمفتاحك
    
    // معالجة البيانات
    let imageSource = '';
    
    if (Array.isArray(src) && src.length > 0) {
        imageSource = src[0];
    } else if (typeof src === 'string') {
        imageSource = src;
    }
    
    const hasImage = imageSource && 
                     typeof imageSource === 'string' && 
                     imageSource.trim() !== '' && 
                     imageSource !== 'null' && 
                     imageSource !== 'undefined' &&
                     (imageSource.startsWith('data:image/') || imageSource.startsWith('http') || imageSource.startsWith('/'));
    
    // دالة تنزيل الصورة
    const downloadImage = (e) => {
        e.stopPropagation();
        
        if (!hasImage) return;
        
        const typeLabel = type === 'personal' ? 'شخصية' : 
                         type === 'passport' ? 'جواز' : 
                         type === 'license' ? 'رخصة' : 
                         type === 'id' ? 'بطاقة' : 'صورة';
        
        const fileName = `${personName}_${typeLabel}.jpg`;
        
        const link = document.createElement('a');
        link.href = imageSource;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    // دالة استخراج النص باستخدام Gemini 1.5
    const extractTextWithGemini = async (e) => {
        e.stopPropagation();
        
        if (!hasImage || isExtracting) return;
        
        // التحقق من وجود مفتاح API
        if (!GEMINI_API_KEY || GEMINI_API_KEY === "YOUR_GEMINI_API_KEY_HERE") {
            alert('يرجى إضافة مفتاح Gemini API في الكود أولاً');
            return;
        }
        
        setIsExtracting(true);
        setExtractedText('');
        
        try {
            console.log('بدء استخراج النص الذكي ...');
            
            // إعداد Gemini
            const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
            const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash" });
            
            // تحويل الصورة إلى format مناسب لـ Gemini
            const imageData = await convertImageForGemini(imageSource);
            
            // النص التوجيهي لـ Gemini
            const prompt = `
قم بتحليل هذه الصورة واستخراج كل النصوص الموجودة فيها بدقة عالية.

التعليمات:
1. استخرج كل النصوص العربية والإنجليزية الموجودة في الصورة
2. احتفظ بالتنسيق والترتيب الأصلي للنصوص كما تظهر في الصورة
3. اكتب النصوص العربية باللغة العربية بوضوح
4. اكتب النصوص الإنجليزية باللغة الإنجليزية بوضوح
5. اكتب الأرقام والتواريخ كما هي بالضبط
6. ضع كل سطر من النص في سطر منفصل
7. لا تضيف أي تفسيرات أو تعليقات أو رموز إضافية
8. لا تترجم أي نص - فقط استخرجه كما هو
9. إذا كان النص غير واضح، اكتبه كما تراه تقريباً
10. فقط النصوص المستخرجة - لا شيء آخر

ابدأ الاستخراج الآن:
            `;
            
            const result = await model.generateContent([prompt, imageData]);
            const response = await result.response;
            const text = response.text();
            
            console.log('تم استخراج النص بنجاح:', text);
            setExtractedText(text.trim());
            setShowTextPanel(true);
            
        } catch (error) {
            console.error('خطأ في استخراج النص:', error);
            let errorMessage = 'حدث خطأ في استخراج النص';
            
            if (error.message.includes('API_KEY')) {
                errorMessage = 'مفتاح Gemini API غير صالح';
            } else if (error.message.includes('quota')) {
                errorMessage = 'تم تجاوز حد الاستخدام لـ Gemini API';
            } else if (error.message.includes('network')) {
                errorMessage = 'خطأ في الاتصال بالإنترنت';
            }
            
            alert(errorMessage);
        } finally {
            setIsExtracting(false);
        }
    };
    
    // تحويل الصورة لـ format مناسب لـ Gemini
    const convertImageForGemini = async (imageSrc) => {
        return new Promise((resolve, reject) => {
            // إذا كانت الصورة base64 بالفعل
            if (imageSrc.startsWith('data:image/')) {
                const base64Data = imageSrc.split(',')[1];
                const mimeType = imageSrc.split(';')[0].split(':')[1];
                
                resolve({
                    inlineData: {
                        data: base64Data,
                        mimeType: mimeType
                    }
                });
            } else {
                // إذا كانت URL عادية، نحولها لـ base64
                const img = new Image();
                img.crossOrigin = 'anonymous';
                
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    
                    canvas.toBlob((blob) => {
                        const reader = new FileReader();
                        reader.onload = () => {
                            const base64Data = reader.result.split(',')[1];
                            resolve({
                                inlineData: {
                                    data: base64Data,
                                    mimeType: 'image/jpeg'
                                }
                            });
                        };
                        reader.readAsDataURL(blob);
                    }, 'image/jpeg', 0.9);
                };
                
                img.onerror = () => reject(new Error('فشل في تحميل الصورة'));
                img.src = imageSrc;
            }
        });
    };
    
    // دالة نسخ النص
    const copyTextToClipboard = () => {
        if (extractedText) {
            navigator.clipboard.writeText(extractedText).then(() => {
                alert('تم نسخ النص بنجاح!');
            }).catch(() => {
                const textArea = document.createElement('textarea');
                textArea.value = extractedText;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                alert('تم نسخ النص بنجاح!');
            });
        }
    };
    
    // دالة حفظ النص في ملف
    const saveTextToFile = () => {
        if (extractedText) {
            const blob = new Blob([extractedText], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${personName}_${type}_نص_مستخرج.txt`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    };
    
    if (!hasImage) {
        return (
            <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center border border-gray-200">
                <span className="text-gray-400 text-xs text-center leading-tight">
                    {type === 'personal' ? '👤' : type === 'passport' ? '📄' : type === 'license' ? '🪪' : '📷'}
                </span>
            </div>
        );
    }
    
    return (
        <>
            <div className="relative group">
                <div 
                    onClick={() => setShowModal(true)}
                    className="w-16 h-16 rounded-lg overflow-hidden cursor-pointer hover:scale-105 transition-transform border-2 border-gray-200 hover:border-blue-400 shadow-sm"
                >
                    <img 
                        src={imageSource} 
                        alt={alt}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            console.log('خطأ في تحميل الصورة:', imageSource);
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = `
                                <div class="w-full h-full bg-gray-100 flex items-center justify-center">
                                    <span class="text-gray-400 text-xs">خطأ</span>
                                </div>
                            `;
                        }}
                    />
                </div>
                
                {/* أزرار العمليات */}
                <div className="absolute -top-2 -right-2 flex flex-col gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    {/* زر التنزيل */}
                    <button
                        onClick={downloadImage}
                        className="w-6 h-6 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg"
                        title="تنزيل الصورة"
                    >
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </button>
                    
                    {/* زر Gemini للاستخراج */}
                    <button
                        onClick={extractTextWithGemini}
                        disabled={isExtracting}
                        className={`w-6 h-6 rounded-full flex items-center justify-center shadow-lg transition-colors ${
                            isExtracting 
                                ? 'bg-yellow-400 cursor-not-allowed animate-pulse' 
                                : 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white'
                        }`}
                        title={isExtracting ? 'جاري الاستخراج بـ ...' : 'استخراج ذكي  '}
                    >
                      {isExtracting ? (
    <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
) : (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 16h4.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7V4a1 1 0 011-1h3M4 17v3a1 1 0 001 1h3m8-21h3a1 1 0 011 1v3m0 8v3a1 1 0 01-1 1h-3" />
    </svg>
)}
                    </button>
                </div>
                
                {/* زر العرض المكبر */}
                <button
                    onClick={() => setShowModal(true)}
                    className="absolute -top-2 -left-2 w-6 h-6 bg-blue-500 hover:bg-blue-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center shadow-lg"
                    title="عرض مكبر"
                >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </button>
            </div>
            
            {/* نافذة العرض المطورة */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4" onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setShowModal(false);
                        setShowTextPanel(false);
                    }
                }}>
                    <div className={`bg-white rounded-2xl overflow-hidden shadow-2xl transition-all duration-300 ${
                        showTextPanel ? 'w-full max-w-7xl h-[95vh]' : 'max-w-5xl max-h-[95vh]'
                    }`}>
                        {/* شريط العنوان */}
                        <div className="p-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white flex justify-between items-center">
                            <div>
                                <h3 className="font-bold text-lg">{alt}</h3>
                                <p className="text-blue-100 text-sm">{personName}</p>
                            </div>
                            <div className="flex gap-2">
                                <button 
                                    onClick={downloadImage}
                                    className="bg-green-500 hover:bg-green-600 px-3 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    تنزيل
                                </button>
                                
                                <button 
                                    onClick={extractTextWithGemini}
                                    disabled={isExtracting}
                                    className={`px-3 py-2 rounded-lg flex items-center gap-2 transition-all duration-300 ${
                                        isExtracting 
                                            ? 'bg-yellow-500 cursor-not-allowed animate-pulse' 
                                            : 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 hover:scale-105'
                                    }`}
                                >
                                    {isExtracting ? (
                                        <>
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                            جاري الاستخراج...
                                        </>
                                    ) : (
                                        <>
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                            استخراج ذكي
                                        </>
                                    )}
                                </button>
                                
                                {showTextPanel && (
                                    <button 
                                        onClick={() => setShowTextPanel(false)}
                                        className="bg-orange-500 hover:bg-orange-600 px-3 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                        title="إخفاء لوحة النص"
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        صورة فقط
                                    </button>
                                )}
                                
                                <button 
                                    onClick={() => {
                                        setShowModal(false);
                                        setShowTextPanel(false);
                                    }}
                                    className="bg-red-500 hover:bg-red-600 px-3 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                >
                                    <X size={16} />
                                    إغلاق
                                </button>
                            </div>
                        </div>
                        
                        {/* المحتوى الرئيسي */}
                        <div className={`flex ${showTextPanel ? 'h-[calc(95vh-80px)]' : ''}`}>
                            {/* قسم الصورة */}
                            <div className={`${showTextPanel ? 'w-1/2 border-r border-gray-200' : 'w-full'} p-6 bg-gray-50 flex items-center justify-center`}>
                                <div className="bg-white rounded-lg p-4 shadow-inner max-w-full max-h-full overflow-auto">
                                    <img 
                                        src={imageSource} 
                                        alt={alt}
                                        className="max-w-full max-h-[70vh] object-contain mx-auto rounded-lg shadow-lg"
                                    />
                                </div>
                            </div>
                            
                            {/* قسم النص المستخرج */}
                            {showTextPanel && (
                                <div className="w-1/2 p-6 bg-gray-100 flex flex-col">
                                    {/* شريط أدوات النص */}
                                    <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-4 rounded-t-lg flex justify-between items-center">
                                        <div>
                                            <h4 className="font-bold text-lg flex items-center gap-2">
                                                <span className="bg-white text-purple-600 px-2 py-1 rounded-full text-sm font-bold">AI</span>
                                                النص المستخرج
                                            </h4>
                                            <p className="text-purple-100 text-sm">عدد الأحرف: {extractedText.length}</p>
                                        </div>
                                        <div className="flex gap-2">
                                            <button 
                                                onClick={saveTextToFile}
                                                className="bg-blue-500 hover:bg-blue-600 px-3 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                                                </svg>
                                                حفظ
                                            </button>
                                            <button 
                                                onClick={copyTextToClipboard}
                                                className="bg-green-500 hover:bg-green-600 px-3 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                                </svg>
                                                نسخ
                                            </button>
                                        </div>
                                    </div>
                                    
                                    {/* محتوى النص */}
                                    <div className="flex-1 bg-white rounded-b-lg border border-gray-200 overflow-hidden">
                                        <div className="h-full overflow-y-auto p-4">
                                            {extractedText ? (
                                                <pre className="whitespace-pre-wrap text-sm text-gray-800 leading-relaxed font-mono">
                                                    {extractedText}
                                                </pre>
                                            ) : (
                                                <div className="h-full flex items-center justify-center text-gray-500">
                                                    <div className="text-center">
                                                        <svg className="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                        </svg>
                                                        <p>اضغط على زر "استخراج ذكي" لاستخراج النص من الصورة</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};



const cleanNotesData = (notes) => {
    if (!notes) return '';
    
    try {
        // إذا كان نص عادي، ارجعه كما هو
        if (typeof notes === 'string' && !notes.includes('{') && !notes.includes('[')) {
            return notes.trim();
        }
        
        // محاولة تنظيف JSON معطوب
        let cleanedNotes = String(notes)
            .replace(/\r\n/g, '\n') // توحيد أسطر جديدة
            .replace(/\r/g, '\n')   // توحيد أسطر جديدة
            .trim();
        
        // إذا كان يبدأ ب [ لكن لا ينتهي ب ]، أصلحه
        if (cleanedNotes.startsWith('[') && !cleanedNotes.endsWith(']')) {
            // ابحث عن آخر } واستبدل ما بعدها بـ ]
            const lastBraceIndex = cleanedNotes.lastIndexOf('}');
            if (lastBraceIndex !== -1) {
                cleanedNotes = cleanedNotes.substring(0, lastBraceIndex + 1) + ']';
            }
        }
        
        return cleanedNotes;
    } catch (error) {
        console.warn('خطأ في تنظيف البيانات:', error);
        return String(notes || '').replace(/[{}[\]"]/g, '').trim();
    }
};

// أضف هذه الدالة مع باقي الدوال
const handleAddPhone = async (passportId, phoneNumber) => {
    try {
        setIsLoading(true);
        
        const response = await fetch(`${config.API_BASE_URL}/api/visa-net-registration/add-phone`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                passportId: passportId,
                phoneNumber: phoneNumber,
                addedBy: 'قسم التأشيرات'
            })
        });
        
        const result = await response.json();
        
        if (result.success) {
            await fetchConfirmedPassports();
            showAlert('تم إضافة رقم الهاتف بنجاح', 'success');
        } else {
            showAlert('فشل في إضافة رقم الهاتف: ' + result.message, 'error');
        }
    } catch (error) {
        console.error('خطأ في إضافة رقم الهاتف:', error);
        showAlert('خطأ في إضافة رقم الهاتف', 'error');
    } finally {
        setIsLoading(false);
    }
};

// في VisaNetRegistration.js، تحديث جزء من getCombinedNotes:

const getCombinedNotes = (combinedNotes) => {
    if (!combinedNotes) return null;
    
    try {
        const cleanNotes = String(combinedNotes).trim();
        if (!cleanNotes) return null;
        
        const parts = cleanNotes.split('--- ملاحظات قسم التأشيرات ---');
        
        if (parts.length > 1) {
            return (
                <div className="space-y-3 max-w-sm">
                    {/* الملاحظات الأصلية */}
                    {parts[0] && parts[0].trim() && (
                        <div className="relative">
                            <div className="bg-gray-50 border-r-4 border-gray-300 rounded-lg p-3 shadow-sm">
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
                                    <span className="font-bold text-gray-700 text-xs">ملاحظات أصلية</span>
                                </div>
                                <div className="text-gray-600 text-xs leading-relaxed">
                                    {(() => {
                                        try {
                                            const originalNotesText = getNotesText(parts[0].trim());
                                            if (!originalNotesText) return <span className="text-gray-400">لا توجد ملاحظات</span>;
                                            
                                            return originalNotesText.split('\n')
                                                .filter(line => line.trim())
                                                .map((line, index) => (
                                                    <div key={`original-${index}`} className="mb-1">
                                                        <span className="inline-block bg-white px-2 py-1 rounded text-xs shadow-sm mr-1 mb-1 border border-gray-100">
                                                            {line.trim()}
                                                        </span>
                                                    </div>
                                                ));
                                        } catch (error) {
                                            return (
                                                <div className="text-yellow-600 text-xs bg-yellow-50 px-2 py-1 rounded">
                                                    ⚠️ خطأ في عرض الملاحظات
                                                </div>
                                            );
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    )}
                    
                    {/* ملاحظات التأشيرات */}
                    {parts[1] && parts[1].trim() && (
                        <div className="relative">
                            <div className="bg-blue-50 border-r-4 border-blue-300 rounded-lg p-3 shadow-sm">
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-2 h-2 bg-blue-300 rounded-full animate-pulse"></div>
                                    <span className="font-bold text-blue-700 text-xs">ملاحظات التأشيرات</span>
                                    <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-medium">
                                        جديد
                                    </span>
                                </div>
                                <div className="text-blue-600 text-xs leading-relaxed">
                                    {(() => {
                                        try {
                                            const visaNotesText = getNotesText(parts[1].trim());
                                            if (!visaNotesText) return <span className="text-blue-400">لا توجد ملاحظات</span>;
                                            
                                            return visaNotesText.split('\n')
                                                .filter(line => line.trim())
                                                .map((line, index) => (
                                                    <div key={`visa-${index}`} className="mb-1">
                                                        <span className="inline-block bg-white px-2 py-1 rounded text-xs shadow-sm mr-1 mb-1 border border-blue-100">
                                                            {line.trim()}
                                                        </span>
                                                    </div>
                                                ));
                                        } catch (error) {
                                            return (
                                                <div className="text-yellow-600 text-xs bg-yellow-50 px-2 py-1 rounded">
                                                    ⚠️ خطأ في عرض الملاحظات
                                                </div>
                                            );
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        }
        
        // ملاحظة واحدة فقط
        return (
            <div className="max-w-sm">
                <div className="bg-gray-50 border-r-4 border-gray-300 rounded-lg p-3 shadow-sm">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
                        <span className="font-bold text-gray-700 text-xs">الملاحظات</span>
                    </div>
                    <div className="text-gray-600 text-xs leading-relaxed">
                        {(() => {
                            try {
                                const notesText = getNotesText(combinedNotes);
                                if (!notesText) return <span className="text-gray-400">لا توجد ملاحظات</span>;
                                
                                return notesText.split('\n')
                                    .filter(line => line.trim())
                                    .map((line, index) => (
                                        <div key={`single-${index}`} className="mb-1">
                                            <span className="inline-block bg-white px-2 py-1 rounded text-xs shadow-sm mr-1 mb-1 border border-gray-100">
                                                {line.trim()}
                                            </span>
                                        </div>
                                    ));
                            } catch (error) {
                                return (
                                    <div className="bg-yellow-50 text-yellow-700 px-2 py-1 rounded text-xs">
                                        ⚠️ خطأ في عرض الملاحظات
                                    </div>
                                );
                            }
                        })()}
                    </div>
                </div>
            </div>
        );
        
    } catch (error) {
        console.error('خطأ عام في getCombinedNotes:', error);
        return (
            <div className="max-w-sm">
                <div className="bg-red-50 border-r-4 border-red-300 rounded-lg p-3">
                    <div className="text-red-600 text-xs">
                        ⚠️ خطأ في تحميل الملاحظات
                    </div>
                </div>
            </div>
        );
    }
};



    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-100 py-6" dir="rtl">
            {/* Alert System */}
            <div className="fixed top-4 right-4 z-50 space-y-2">
                {alerts.map(alert => (
                    <div
                        key={alert.id}
                        className={`p-4 rounded-lg shadow-lg flex items-center gap-3 transition-all duration-300 ${
                            alert.type === 'success' ? 'bg-green-500 text-white' :
                            alert.type === 'warning' ? 'bg-yellow-500 text-white' :
                            alert.type === 'error' ? 'bg-red-500 text-white' :
                            'bg-blue-500 text-white'
                        }`}
                    >
                        {alert.type === 'success' && <CheckCircle2 size={20} />}
                        {alert.type === 'warning' && <AlertTriangle size={20} />}
                        {alert.type === 'error' && <AlertTriangle size={20} />}
                        {alert.type === 'info' && <Bell size={20} />}
                        <span className="font-medium">{alert.message}</span>
                    </div>
                ))}
            </div>

<div className="max-w-[2400px] mx-auto px-2 sm:px-4 lg:px-6">
                {/* Header */}
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                    <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-green-600 text-white rounded-lg">
                                <FileText size={28} />
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900">قسم التأشيرات</h1>
                                <p className="text-gray-600">معالجة طلبات التأشيرات المؤكدة من قسم الجوازات</p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2 justify-end [&_button]:whitespace-nowrap">

                                    {/* 🆕 زر تبديل الوضع */}
        <button
            onClick={() => setQuickInputMode(!quickInputMode)}
            className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-300 ${
                quickInputMode 
                    ? 'bg-orange-600 hover:bg-orange-700 text-white' 
                    : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
        >
            {quickInputMode ? (
                <>
                    <Eye size={18} />
                    العرض العادي
                </>
            ) : (
                <>
                    <Edit3 size={18} />
                    وضع الإدخال السريع
                </>
            )}
        </button>



                        <div className="relative">



                                    <button 
                                        onClick={() => setShowNotificationsModal(true)}
                                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 animate-pulse"
                                    >
                                        <Bell size={18} />
                                        إشعارات جديدة ({unreadCount})
                                    </button>
                                </div>

                                <button
        onClick={() => {
            setShowWalletManagementModal(true);
            fetchFinancialStats();
        }}
        className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
    >
        <Wallet size={18} />
        إدارة المحافظ
    </button>

    <button
        onClick={() => {
            setShowInternalTransactionModal(true);
        }}
        className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
    >
        <Calculator size={18} />
        معاملة داخلية
    </button>

    <button
        onClick={() => {
            setShowFinancialReportModal(true);
            fetchFinancialTransactions();
            fetchFinancialStats();
        }}
        className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
    >
        <BarChart3 size={18} />
        التقرير المالي
    </button>












                            <button
                                onClick={() => setShowPaymentMethodsModal(true)}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
                            >
                                <Settings size={18} />
                                إدارة طرق الدفع
                            </button>
                            <button
                                onClick={fetchConfirmedPassports}
                                disabled={isLoading}
                                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 disabled:opacity-50"
                            >
                                {isLoading ? <RefreshCw className="animate-spin" size={18} /> : <RefreshCw size={18} />}
                                تحديث
                            </button>
                            <button
                                onClick={() => navigate('/')}
                                className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
                            >
                                <ArrowLeft size={18} />
                                الرئيسية
                            </button>
                        </div>
                    </div>

                    {/* Statistics */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-4 bg-gray-50 rounded-lg">
                        <div className="text-center">
                            <div className="text-2xl font-bold text-blue-600">{confirmedPassports.length}</div>
                            <div className="text-sm text-gray-600">إجمالي المؤكدين</div>
                        </div>
                        <div className="text-center">
                            <div className="text-2xl font-bold text-green-600">
                                {confirmedPassports.filter(p => p.FinalStatus === 'مكتمل').length}
                            </div>
                            <div className="text-sm text-gray-600">مكتمل</div>
                        </div>
                        <div className="text-center">
                            <div className="text-2xl font-bold text-yellow-600">
                                {confirmedPassports.filter(p => !p.FinalStatus || p.FinalStatus === 'في الانتظار').length}
                            </div>
                            <div className="text-sm text-gray-600">في الانتظار</div>
                        </div>
                        <div className="text-center">
                            <div className="text-2xl font-bold text-purple-600">
                                {confirmedPassports.filter(p => p.PaymentStatus === 'مدفوع').length}
                            </div>
                            <div className="text-sm text-gray-600">مدفوع</div>
                        </div>
                    </div>

                    {/* Search and Filter */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                        <div className="relative">
                            <Search size={20} className="absolute right-3 top-3 text-gray-400" />
                            <input
                                type="text"
                                placeholder="ابحث بالاسم أو رقم الجواز أو الشركة أو المندوب..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-4 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                            />
                        </div>
                        <div className="relative">
                            <Filter size={20} className="absolute right-3 top-3 text-gray-400" />
                            <select
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                                className="w-full pl-4 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                            >
                                <option value="all">كل الحالات</option>
                                <option value="pending">في الانتظار</option>
                                <option value="completed">مكتمل</option>
                                <option value="paid">مدفوع</option>
                                <option value="unpaid">غير مدفوع</option>
                            </select>
                        </div>
                    </div>
                </div>

{/* Main Table */}
<div className="bg-white rounded-xl shadow-lg overflow-hidden">
{getFilteredPassports().length > 0 ? (
    <div className="overflow-x-auto">
        <table className="w-full">
            <thead className="bg-gray-50">
                <tr>
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">م</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">الصور</th>}
                    <th className="px-4 py-3 text-right font-medium text-gray-700 sticky-name bg-gray-50">الاسم</th>
                    <th className="px-4 py-3 text-right font-medium text-gray-700">الشركة + ID</th>
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">المهنة</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">الهاتف</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">المندوب</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">حالة الجوازات</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">الحالة النهائية</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">تاريخ النت</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">رقم الجواز</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">رقم الطلب</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">تاريخ البصمة</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">الملاحظات</th>}
                    {!quickInputMode && <th className="px-4 py-3 text-right font-medium text-gray-700">حالة الدفع</th>}
                    
                    {/* 🆕 أعمدة البيانات الإضافية في الوضع السريع */}
                    {quickInputMode && (
                        <>
                            <th className="px-4 py-3 text-right font-medium text-blue-700 bg-blue-50">رقم التأشيرة</th>
                            <th className="px-4 py-3 text-right font-medium text-blue-700 bg-blue-50">رقم صاحب العمل</th>
                            <th className="px-4 py-3 text-right font-medium text-blue-700 bg-blue-50">المهنة التفصيلية</th>
                            <th className="px-4 py-3 text-right font-medium text-blue-700 bg-blue-50">الشركة التفصيلية</th>
                            <th className="px-4 py-3 text-right font-medium text-green-700 bg-green-50">نسبة الاكتمال</th>
                        </>
                    )}
                    
                    <th className="px-4 py-3 text-right font-medium text-gray-700">
                        {quickInputMode ? 'إجراءات' : 'الإجراءات'}
                    </th>
                </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
                {getFilteredPassports().map((passport, index) => (
                    <React.Fragment key={passport.PassportID}>
                        <tr className={`hover:bg-gray-50 ${quickInputMode ? 'bg-blue-25' : ''} ${
    hasUnsavedChanges(passport.PassportID) ? 'border-r-4 border-orange-400 bg-orange-50' : ''
}`}>
                            {/* العرض العادي */}
                            {!quickInputMode && (
                                <>
                                    {/* الرقم المسلسل */}
                                    <td className="px-4 py-3">
                                        <div className="w-8 h-8 bg-blue-50 text-blue-700 rounded-full flex items-center justify-center text-sm font-bold">
                                            {index + 1}
                                        </div>
                                    </td>

                                    {/* الصور */}
                                    <td className="px-4 py-3">
                                        <div className="flex gap-2">
                                            <div className="text-center">
                                                <ImageViewer 
                                                    src={passport.PersonalImage} 
                                                    alt={`الصورة الشخصية لـ ${passport.NameArabic}`}
                                                    type="personal"
                                                    personName={passport.NameArabic}
                                                />
                                                <span className="text-xs text-gray-500 mt-1 block font-medium">شخصية</span>
                                            </div>
                                            <div className="text-center">
                                                <ImageViewer 
                                                    src={passport.PassportImage} 
                                                    alt={`صورة جواز ${passport.NameArabic}`}
                                                    type="passport"
                                                    personName={passport.NameArabic}
                                                />
                                                <span className="text-xs text-gray-500 mt-1 block font-medium">جواز</span>
                                            </div>
                                        </div>
                                    </td>
                                </>
                            )}

                            {/* الاسم */}
                            <td className="px-4 py-3 min-w-[9rem] sticky-name bg-white">
                                <div className={`font-medium ${quickInputMode ? 'text-lg' : ''} text-gray-900`}>
                                    {passport.NameArabic}
                                </div>
                                {quickInputMode && (
                                    <div className="text-sm text-gray-500">
                                        {passport.PassportProfessionName} | {passport.DelegateName}
                                    </div>
                                )}
                            </td>

                            {/* الشركة + ID */}
                            <td className="px-4 py-3 min-w-[6.5rem]">
                                <div>
                                    <div className={`font-medium text-gray-900 ${quickInputMode ? 'text-base' : 'text-sm'}`}>
                                        {passport.CompanyName}
                                    </div>
                                    <div className="text-xs text-blue-600 bg-blue-50 px-2 py-0.5 rounded font-mono whitespace-nowrap inline-block">
                                        ID: {passport.PassportID}
                                    </div>
                                </div>
                            </td>

                            {/* الأعمدة في العرض العادي فقط */}
                            {!quickInputMode && (
                                <>
                                    {/* المهنة */}
                                    <td className="px-4 py-3">
                                        <span className="px-2 py-1 bg-purple-50 text-purple-700 rounded text-xs">
                                            {passport.PassportProfessionName || 'غير محدد'}
                                        </span>
                                    </td>

                                    {/* الهاتف */}
                                    <td className="px-4 py-3">
                                        <div className="max-w-xs space-y-2">
                                            {(() => {
                                                const combinedPhones = passport.CombinedPhones;
                                                if (!combinedPhones) return <span className="text-gray-400">لا يوجد</span>;
                                                
                                                try {
                                                    if (typeof combinedPhones === 'string') {
                                                        const parts = combinedPhones.split(' | إضافي: ');
                                                        if (parts.length > 1) {
                                                            const originalPhones = getPhoneNumbers(parts[0]);
                                                            const additionalPhones = getPhoneNumbers(parts[1]);
                                                            
                                                            return (
                                                                <div className="space-y-2">
                                                                    {/* الأرقام الأساسية */}
                                                                    {originalPhones.length > 0 && originalPhones.map((phone, index) => (
                                                                        <div key={`original-${index}`} className="flex items-center gap-2">
                                                                            <div className="w-2 h-2 bg-green-300 rounded-full"></div>
                                                                            <span className="text-gray-800 font-medium bg-green-50 px-3 py-1 rounded-full text-sm border border-green-100">
                                                                                📞 {phone}
                                                                            </span>
                                                                            {index === 0 && (
                                                                                <span className="bg-green-50 text-green-600 px-2 py-0.5 rounded-full text-xs font-medium">
                                                                                    أساسي
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                    
                                                                    {/* الأرقام الإضافية */}
                                                                    {additionalPhones.length > 0 && additionalPhones.map((phone, index) => (
                                                                        <div key={`additional-${index}`} className="flex items-center gap-2 group">
                                                                            <div className="w-2 h-2 bg-blue-300 rounded-full animate-pulse"></div>
                                                                            <span className="text-blue-600 font-medium bg-blue-50 px-3 py-1 rounded-full text-sm border border-blue-100">
                                                                                📱 {phone}
                                                                            </span>
                                                                            <span className="bg-orange-50 text-orange-600 px-2 py-0.5 rounded-full text-xs font-medium">
                                                                                إضافي
                                                                            </span>
                                                                            <button
                                                                                onClick={() => handleDeletePhone(passport.PassportID, phone)}
                                                                                className="opacity-0 group-hover:opacity-100 bg-red-50 hover:bg-red-100 text-red-600 p-1 rounded-full transition-all duration-200 hover:scale-110"
                                                                                title="حذف هذا الرقم"
                                                                            >
                                                                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                    
                                                                    <button
                                                                        onClick={() => {
                                                                            const newPhone = prompt('أدخل رقم الهاتف الجديد (11 رقم):');
                                                                            if (newPhone && /^01[0-9]{9}$/.test(newPhone)) {
                                                                                handleAddPhone(passport.PassportID, newPhone);
                                                                            } else if (newPhone) {
                                                                                showAlert('رقم الهاتف يجب أن يبدأ بـ 01 ويكون 11 رقم', 'error');
                                                                            }
                                                                        }}
                                                                        className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-xs bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-full transition-colors"
                                                                        title="إضافة رقم هاتف"
                                                                    >
                                                                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                                        </svg>
                                                                        إضافة رقم
                                                                    </button>
                                                                </div>
                                                            );
                                                        }
                                                        
                                                        const phones = getPhoneNumbers(combinedPhones);
                                                        return (
                                                            <div className="space-y-1">
                                                                {phones.map((phone, index) => (
                                                                    <div key={`single-${index}`} className="flex items-center gap-2">
                                                                        <div className="w-2 h-2 bg-green-300 rounded-full"></div>
                                                                        <span className="text-gray-800 font-medium bg-green-50 px-3 py-1 rounded-full text-sm border border-green-100">
                                                                            📞 {phone}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                                <button
                                                                    onClick={() => {
                                                                        const newPhone = prompt('أدخل رقم الهاتف الجديد (11 رقم):');
                                                                        if (newPhone && /^01[0-9]{9}$/.test(newPhone)) {
                                                                            handleAddPhone(passport.PassportID, newPhone);
                                                                        } else if (newPhone) {
                                                                            showAlert('رقم الهاتف يجب أن يبدأ بـ 01 ويكون 11 رقم', 'error');
                                                                        }
                                                                    }}
                                                                    className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-xs bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-full transition-colors"
                                                                    title="إضافة رقم هاتف"
                                                                >
                                                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                                    </svg>
                                                                    إضافة رقم
                                                                </button>
                                                            </div>
                                                        );
                                                    }
                                                    return getPhoneNumbers(combinedPhones.toString());
                                                } catch (error) {
                                                    return getPhoneNumbers(combinedPhones || '');
                                                }
                                            })()}
                                        </div>
                                    </td>

                                    {/* المندوب */}
                                    <td className="px-4 py-3">
                                        <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-sm">
                                            {passport.DelegateName}
                                        </span>
                                    </td>

                                    {/* حالة الجوازات */}
                                    <td className="px-4 py-3">
                                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                                            passport.NetWorkDate ? 'bg-green-50 text-green-700' : 
                                            passport.NetConfirmed ? 'bg-yellow-50 text-yellow-700' : 
                                            'bg-gray-50 text-gray-600'
                                        }`}>
                                            {passport.AttendanceStatus || (
                                                passport.NetWorkDate ? '✅ تم عمل النت' : 
                                                passport.NetConfirmed ? '⏳ حضر - بانتظار النت' : 
                                                '❌ لم يحضر'
                                            )}
                                        </span>
                                    </td>

                                    {/* الحالة النهائية */}
                                    <td className="px-4 py-3">
                                        <select
                                            value={passport.FinalStatus || ''}
                                            onChange={(e) => updateFinalStatus(passport.PassportID, e.target.value)}
                                            className={`px-3 py-1 rounded-full text-sm font-medium border-0 ${getStatusColor(passport.FinalStatus)}`}
                                        >
                                            <option value="">اختر الحالة النهائية</option>
                                            <option value="جاري العمل">جاري العمل</option>
                                            <option value="مكتمل">مكتمل</option>
                                            <option value="مؤجل">مؤجل</option>
                                            <option value="ملغي">ملغي</option>
                                        </select>
                                    </td>

                                    {/* تاريخ النت */}
                                    <td className="px-4 py-3 text-sm whitespace-nowrap">
                                        {passport.NetWorkDate ? (
                                            <div className="text-green-600 font-medium">
                                                {new Date(passport.NetWorkDate).toLocaleDateString('ar-EG')}
                                            </div>
                                        ) : (
                                            <span className="text-gray-400">غير محدد</span>
                                        )}
                                    </td>

                                    {/* رقم الجواز */}
                                    <td className="px-4 py-3">
                                        {editingPassportNumber === passport.PassportID ? (
                                            <div className="flex items-center gap-2 bg-red-50 p-3 rounded-lg border-2 border-red-200 shadow-sm">
                                                <input
                                                    type="text"
                                                    value={tempPassportNumber}
                                                    onChange={(e) => {
                                                        let value = e.target.value.toUpperCase();
                                                        if (!value.startsWith("A")) {
                                                            value = "A" + value.replace(/[^0-9]/g, "");
                                                        } else {
                                                            value = "A" + value.slice(1).replace(/[^0-9]/g, "");
                                                        }
                                                        if (value.length <= 9) {
                                                            setTempPassportNumber(value);
                                                        }
                                                    }}
                                                    className="border-0 bg-white rounded-lg px-3 py-2 text-sm w-32 focus:ring-2 focus:ring-red-400 focus:outline-none shadow-sm font-mono"
                                                    placeholder="A12345678"
                                                    autoFocus
                                                    maxLength={9}
                                                />
                                                <button
                                                    onClick={() => savePassportNumber(passport.PassportID)}
                                                    disabled={isLoading}
                                                    className="bg-green-400 hover:bg-green-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105 disabled:opacity-50"
                                                    title="حفظ"
                                                >
                                                    {isLoading ? (
                                                        <RefreshCw className="animate-spin" size={16} />
                                                    ) : (
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                    )}
                                                </button>
                                                <button
                                                    onClick={cancelPassportNumberEdit}
                                                    className="bg-red-400 hover:bg-red-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                                                    title="إلغاء"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2">
                                                {passport.PassportNumber ? (
                                                    <div className="bg-red-50 text-red-700 px-4 py-2 rounded-lg text-sm font-mono border border-red-200 shadow-sm">
                                                        {passport.PassportNumber}
                                                    </div>
                                                ) : (
                                                    <div className="bg-gray-50 text-gray-500 px-4 py-2 rounded-lg text-sm border border-gray-200 italic">
                                                        غير محدد
                                                    </div>
                                                )}
                                                <button
                                                    onClick={() => {
                                                        setEditingPassportNumber(passport.PassportID);
                                                        setTempPassportNumber(passport.PassportNumber || 'A');
                                                    }}
                                                    className="bg-red-400 hover:bg-red-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                                                    title="تعديل رقم الجواز (احتياطي)"
                                                >
                                                    <Edit3 size={16} />
                                                </button>
                                            </div>
                                        )}
                                    </td>

                                    {/* رقم الطلب */}
                                    <td className="px-4 py-3">
                                        {editingApplicationNumber === passport.PassportID ? (
                                            <div className="flex items-center gap-2 bg-blue-50 p-3 rounded-lg border-2 border-blue-200 shadow-sm">
                                                <input
                                                    type="text"
                                                    value={tempApplicationNumber}
                                                    onChange={(e) => setTempApplicationNumber(e.target.value)}
                                                    className="border-0 bg-white rounded-lg px-3 py-2 text-sm w-36 focus:ring-2 focus:ring-blue-400 focus:outline-none shadow-sm font-mono"
                                                    placeholder="ادخل رقم الطلب"
                                                    autoFocus
                                                />
                                                <button
                                                    onClick={() => saveApplicationNumber(passport.PassportID)}
                                                    disabled={isLoading}
                                                    className="bg-green-400 hover:bg-green-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105 disabled:opacity-50"
                                                    title="حفظ"
                                                >
                                                    {isLoading ? (
                                                        <RefreshCw className="animate-spin" size={16} />
                                                    ) : (
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                    )}
                                                </button>
                                                <button
                                                    onClick={() => cancelEdit('application')}
                                                    className="bg-red-400 hover:bg-red-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                                                    title="إلغاء"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2">
                                                {passport.ApplicationNumber ? (
                                                    <div className="bg-green-50 text-green-700 px-4 py-2 rounded-lg text-sm font-mono border border-green-200 shadow-sm">
                                                        {cleanDuplicatedApplicationNumber(passport.ApplicationNumber)}
                                                    </div>
                                                ) : (
                                                    <div className="bg-gray-50 text-gray-500 px-4 py-2 rounded-lg text-sm border border-gray-200 italic">
                                                        غير محدد
                                                    </div>
                                                )}
                                                <button
                                                    onClick={() => {
                                                        setEditingApplicationNumber(passport.PassportID);
                                                        setTempApplicationNumber(cleanDuplicatedApplicationNumber(passport.ApplicationNumber || ''));
                                                    }}
                                                    className="bg-blue-400 hover:bg-blue-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                                                    title="تعديل رقم الطلب"
                                                >
                                                    <Edit3 size={16} />
                                                </button>
                                            </div>
                                        )}
                                    </td>

                                    {/* تاريخ البصمة */}
                                    <td className="px-4 py-3">
                                        {editingFingerprintDate === passport.PassportID ? (
                                            <div className="flex items-center gap-2 bg-purple-50 p-3 rounded-lg border-2 border-purple-200 shadow-sm">
                                                <input
                                                    type="date"
                                                    value={tempFingerprintDate}
                                                    onChange={(e) => setTempFingerprintDate(e.target.value)}
                                                    className="border-0 bg-white rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none shadow-sm w-full"
                                                    autoFocus
                                                />
                                                <button
                                                    onClick={() => saveFingerprintDate(passport.PassportID)}
                                                    disabled={isLoading}
                                                    className="bg-green-400 hover:bg-green-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105 disabled:opacity-50"
                                                    title="حفظ"
                                                >
                                                    {isLoading ? (
                                                        <RefreshCw className="animate-spin" size={16} />
                                                    ) : (
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                    )}
                                                </button>
                                                <button
                                                    onClick={() => cancelEdit('fingerprint')}
                                                    className="bg-red-400 hover:bg-red-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                                                    title="إلغاء"
                                                >
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2">
                                                {passport.FingerprintDate ? (
                                                    <div className="bg-purple-50 text-purple-700 px-4 py-3 rounded-lg text-base border border-purple-200 shadow-sm font-medium min-w-[120px] text-center">
                                                        <div className="flex items-center gap-2 justify-center">
                                                            <svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                            </svg>
                                                            <span className="font-bold">
                                                                {(() => {
                                                                    try {
                                                                        const date = new Date(passport.FingerprintDate);
                                                                        return date.toLocaleDateString('ar-EG', {
                                                                            year: 'numeric',
                                                                            month: '2-digit',
                                                                            day: '2-digit'
                                                                        });
                                                                    } catch (error) {
                                                                        return 'تاريخ غير صحيح';
                                                                    }
                                                                })()}
                                                            </span>
                                                        </div>
                                                        <div className="text-xs text-purple-600 mt-1">
                                                            موعد البصمة
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="bg-gray-50 text-gray-500 px-4 py-3 rounded-lg text-base border border-gray-200 italic min-w-[120px] text-center">
                                                       <div className="flex items-center gap-2 justify-center">
                                                           <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                           </svg>
                                                           <span>غير محدد</span>
                                                       </div>
                                                   </div>
                                               )}
                                               <button
                                                   onClick={() => {
                                                       setEditingFingerprintDate(passport.PassportID);
                                                       let dateValue = '';
                                                       if (isValidDate(passport.FingerprintDate)) {
                                                           try {
                                                               const date = new Date(passport.FingerprintDate);
                                                               dateValue = date.toISOString().split('T')[0];
                                                           } catch (error) {
                                                               console.log('خطأ في تحويل التاريخ للتعديل:', error);
                                                               dateValue = '';
                                                           }
                                                       }
                                                       setTempFingerprintDate(dateValue);
                                                   }}
                                                   className="bg-purple-400 hover:bg-purple-500 text-white p-2 rounded-lg shadow-md transition-all duration-200 hover:scale-105"
                                                   title="تعديل تاريخ البصمة"
                                               >
                                                   <Edit3 size={16} />
                                               </button>
                                           </div>
                                       )}
                                   </td>

                                   {/* الملاحظات */}
                                   <td className="px-4 py-3">
                                       <div className="relative group">
                                           <div className="max-w-xs">
                                               {passport.CombinedNotes && (
                                                   <div className="cursor-pointer" onClick={() => handleShowFullNotes(passport)}>
                                                       {getCombinedNotes(passport.CombinedNotes)}
                                                       
                                                       {getNotesText(passport.CombinedNotes).length > 100 && (
                                                           <div className="mt-2 text-center">
                                                               <span className="inline-flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-600 px-2 py-1 rounded-full text-xs cursor-pointer transition-colors">
                                                                   <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                                   </svg>
                                                                   عرض المزيد
                                                               </span>
                                                           </div>
                                                       )}
                                                   </div>
                                               )}
                                           </div>
                                           
                                           <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10 max-w-sm">
                                               انقر لعرض الملاحظات كاملة
                                           </div>
                                       </div>
                                   </td>

                                   {/* حالة الدفع */}
                                   <td className="px-4 py-3">
                                       <div className="space-y-2">
                                           <span className={`px-3 py-1 rounded-full text-sm font-medium ${getPaymentStatusColor(passport.PaymentStatus || 'غير مدفوع')}`}>
                                               {passport.PaymentStatus === 'مدفوع' && '💰 '}
                                               {passport.PaymentStatus === 'مسترد' && '↩️ '}
                                               {passport.PaymentStatus === 'ملغي' && '❌ '}
                                               {passport.PaymentStatus || 'غير مدفوع'}
                                           </span>
                                           {passport.PaymentAmount && (
                                               <div className="text-xs text-gray-500">
                                                   المبلغ: {passport.PaymentAmount} 
                                                   {passport.PaymentMethod && ` - ${passport.PaymentMethod}`}
                                               </div>
                                           )}
                                           {passport.PaymentDate && (
                                               <div className="text-xs text-gray-400">
                                                   {new Date(passport.PaymentDate).toLocaleDateString('ar-EG')}
                                               </div>
                                           )}
                                       </div>
                                   </td>
                               </>
                           )}

                           {/* 🆕 أعمدة البيانات الإضافية في الوضع السريع */}
                           {quickInputMode && (
                               <>
{/* رقم التأشيرة */}
<td className="px-4 py-3">
    <input
        type="text"
        value={getFieldValue(passport.PassportID, 'VisaNumber')}
        onChange={(e) => {
            e.persist();
            updateTempData(passport.PassportID, 'VisaNumber', e.target.value);
        }}
        placeholder="1303938698"
        className="w-full border border-blue-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50"
    />
</td>

{/* رقم صاحب العمل */}
<td className="px-4 py-3">
    <input
        type="text"
        value={getFieldValue(passport.PassportID, 'EmployerNumber')}
        onChange={(e) => {
            e.persist();
            updateTempData(passport.PassportID, 'EmployerNumber', e.target.value);
        }}
        placeholder="7012483983"
        className="w-full border border-blue-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50"
    />
</td>

{/* المهنة التفصيلية */}
<td className="px-4 py-3">
    <input
        type="text"
        value={getFieldValue(passport.PassportID, 'DetailedProfession')}
        onChange={(e) => {
            e.persist();
            updateTempData(passport.PassportID, 'DetailedProfession', e.target.value);
        }}
        placeholder="مهندس برمجيات..."
        className="w-full border border-blue-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50"
    />
</td>

{/* الشركة التفصيلية */}
<td className="px-4 py-3">
    <input
        type="text"
        value={getFieldValue(passport.PassportID, 'DetailedCompanyName')}
        onChange={(e) => {
            e.persist();
            updateTempData(passport.PassportID, 'DetailedCompanyName', e.target.value);
        }}
        placeholder="شركة التقنية المتقدمة..."
        className="w-full border border-blue-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50"
    />
</td>


        {/* نسبة الاكتمال */}
        <td className="px-4 py-3">
            <div className="flex items-center gap-2">
                <div className="w-16 bg-gray-200 rounded-full h-2">
                    <div 
                        className={`h-2 rounded-full transition-all duration-300 ${
                            (passport.CompletionPercentage || 0) === 100 ? 'bg-green-500' :
                            (passport.CompletionPercentage || 0) >= 75 ? 'bg-blue-500' :
                            (passport.CompletionPercentage || 0) >= 50 ? 'bg-yellow-500' :
                            'bg-red-500'
                        }`}
                        style={{ width: `${passport.CompletionPercentage || 0}%` }}
                    ></div>
                </div>
                <span className={`text-sm font-medium ${
                    (passport.CompletionPercentage || 0) === 100 ? 'text-green-600' :
                    (passport.CompletionPercentage || 0) >= 75 ? 'text-blue-600' :
                    (passport.CompletionPercentage || 0) >= 50 ? 'text-yellow-600' :
                    'text-red-600'
                }`}>
                    {passport.CompletionPercentage || 0}%
                </span>
            </div>
        </td>
    </>
)}

                           {/* الإجراءات */}
                           <td className="px-4 py-3">
                              <div className="flex items-center gap-2">
    {/* زر الحفظ - يظهر فقط لو فيه تغييرات */}
    {quickInputMode && hasUnsavedChanges(passport.PassportID) && (
        <button
            onClick={() => saveAllAdditionalData(passport.PassportID)}
            disabled={isLoading}
            className="bg-green-500 hover:bg-green-600 text-white p-2 rounded-lg transition-colors flex items-center gap-1 animate-pulse"
            title="حفظ جميع البيانات المعدلة"
        >
            {isLoading ? (
                <RefreshCw className="animate-spin" size={16} />
            ) : (
                <Save size={16} />
            )}
            <span className="text-xs">حفظ</span>
        </button>
    )}
                                   {/* زر التوسيع في العرض العادي */}
                                   {!quickInputMode && (
                                       <button
                                           onClick={() => toggleExpandedRow(passport.PassportID)}
                                           className={`p-2 rounded-lg transition-all duration-200 ${
                                               expandedRows.has(passport.PassportID)
                                                   ? 'bg-blue-600 text-white'
                                                   : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
                                           }`}
                                           title={expandedRows.has(passport.PassportID) ? 'إخفاء البيانات الإضافية' : 'إظهار البيانات الإضافية'}
                                       >
                                           {expandedRows.has(passport.PassportID) ? (
                                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                               </svg>
                                           ) : (
                                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                               </svg>
                                           )}
                                       </button>
                                   )}

                                   {/* الأزرار الموجودة */}
                                   <button
                                       onClick={() => {
                                           setSelectedPassport(passport);
                                           setShowAdvancedPaymentModal(true);
                                       }}
                                       className="bg-green-50 hover:bg-green-100 text-green-700 p-2 rounded-lg transition-colors flex items-center gap-1"
                                       title="إدارة المدفوعات المتقدمة"
                                   >
                                       <CreditCard size={16} />
                                   </button>
                                   
                                   <button
                                       onClick={() => {
                                           setSelectedPassport(passport);
                                           setShowRemoveModal(true);
                                       }}
                                       className="bg-red-50 hover:bg-red-100 text-red-700 p-2 rounded-lg transition-colors"
                                       title="حذف من قائمة التأشيرات"
                                   >
                                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                       </svg>
                                   </button>

                                   {/* زر البيانات الإضافية في الوضع السريع */}
                                   {quickInputMode && (
                                       <button
                                           onClick={() => {
                                               setSelectedPassportForAdditionalData(passport);
                                               setAdditionalDataForm({
                                                   visaNumber: passport.VisaNumber || '',
                                                   employerNumber: passport.EmployerNumber || '',
                                                   detailedProfession: passport.DetailedProfession || '',
                                                   detailedCompanyName: passport.DetailedCompanyName || ''
                                               });
                                               setShowAdditionalDataModal(true);
                                           }}
                                           className="bg-purple-50 hover:bg-purple-100 text-purple-700 p-2 rounded-lg transition-colors"
                                           title="تعديل في نافذة منفصلة"
                                       >
                                           <Edit3 size={16} />
                                       </button>
                                   )}
                               </div>
                           </td>
                       </tr>

                       {/* 🆕 الصف المتوسع */}
                       {!quickInputMode && <ExpandableRow passport={passport} />}
                   </React.Fragment>
               ))}
           </tbody>
       </table>
   </div>
) : (
   <div className="text-center py-12">
       <Users className="mx-auto h-16 w-16 text-gray-400 mb-4" />
       <h3 className="text-lg font-medium text-gray-900 mb-2">لا توجد طلبات مؤكدة</h3>
       <p className="text-gray-600">ستظهر هنا الطلبات المؤكدة من قسم الجوازات</p>
   </div>
)}
      </div>
       </div>

                   {/* نافذة الدفع المتقدم - استبدال showPaymentModal */}
{showAdvancedPaymentModal && selectedPassport && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg">
            <div className="bg-green-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold">💳 العمليات المالية المتقدمة</h3>
                    <button
                        onClick={() => setShowAdvancedPaymentModal(false)}
                        className="text-white hover:bg-green-700 p-2 rounded-full"
                    >
                        <X size={20} />
                    </button>
                </div>
                <p className="text-green-100 mt-2">{selectedPassport.NameArabic}</p>
            </div>
            
            <div className="p-6 space-y-4">
                {/* نوع العملية */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        نوع العملية
                    </label>
                    <select
                        value={advancedPaymentForm.paymentType}
                        onChange={(e) => setAdvancedPaymentForm(prev => ({ ...prev, paymentType: e.target.value }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500"
                    >
                        <option value="payment">💰 دفع جديد</option>
                        <option value="refund">↩️ استرداد</option>
                        <option value="cancel">❌ إلغاء المعاملة</option>
                    </select>
                </div>

            {/* المبلغ الأساسي */}
<div>
    <label className="block text-sm font-medium text-gray-700 mb-2">
        المبلغ الأساسي
    </label>
    <input
        type="number"
        value={advancedPaymentForm.baseAmount}
        onChange={(e) => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: Number(e.target.value) }))}
        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500"
        disabled={advancedPaymentForm.paymentType === 'cancel'}
        placeholder="أدخل المبلغ الأساسي..."
    />
    
    {/* أزرار مبالغ سريعة */}
    <div className="flex gap-2 mt-2">

          <button
            type="button"
            onClick={() => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: 4000 }))}
            className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
        >
            4000
        </button>

        <button
            type="button"
            onClick={() => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: 3000 }))}
            className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
        >
            3000
        </button>
        <button
            type="button"
            onClick={() => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: 2500 }))}
            className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
        >
            2500
        </button>
        <button
            type="button"
            onClick={() => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: 2000 }))}
            className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
        >
            2000
        </button>
        <button
            type="button"
            onClick={() => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: 1500 }))}
            className="px-3 py-1 bg-blue-100 text-blue-700 rounded text-sm hover:bg-blue-200"
        >
            1500
        </button>
        <button
            type="button"
            onClick={() => setAdvancedPaymentForm(prev => ({ ...prev, baseAmount: 0 }))}
            className="px-3 py-1 bg-red-100 text-red-700 rounded text-sm hover:bg-red-200"
        >
            مسح
        </button>
    </div>
</div>
                
                {/* الخصم */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        الخصم
                    </label>
                    <input
                        type="number"
                        value={advancedPaymentForm.discount}
                        onChange={(e) => setAdvancedPaymentForm(prev => ({ ...prev, discount: Number(e.target.value) }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500"
                        disabled={advancedPaymentForm.paymentType === 'cancel'}
                    />
                </div>
                
                {/* مبلغ إضافي */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        مبلغ إضافي
                    </label>
                    <input
                        type="number"
                        value={advancedPaymentForm.additionalAmount}
                        onChange={(e) => setAdvancedPaymentForm(prev => ({ ...prev, additionalAmount: Number(e.target.value) }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500"
                        disabled={advancedPaymentForm.paymentType === 'cancel'}
                    />
                </div>
                
                {/* المبلغ الإجمالي */}
                <div className={`rounded-lg p-4 ${
                    advancedPaymentForm.paymentType === 'payment' ? 'bg-green-50' :
                    advancedPaymentForm.paymentType === 'refund' ? 'bg-red-50' :
                    'bg-gray-50'
                }`}>
                    <div className="text-lg font-bold text-gray-900">
                        المبلغ الإجمالي: {advancedPaymentForm.baseAmount - advancedPaymentForm.discount + advancedPaymentForm.additionalAmount} 
                        {advancedPaymentForm.paymentType === 'payment' && ' (سيُضاف للمحفظة)'}
                        {advancedPaymentForm.paymentType === 'refund' && ' (سيُخصم من المحفظة)'}
                        {advancedPaymentForm.paymentType === 'cancel' && ' (لن يؤثر على الرصيد)'}
                    </div>
                </div>
                
                {/* اختيار المحفظة */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        المحفظة
                    </label>
                    <select
                        value={advancedPaymentForm.walletId}
                        onChange={(e) => setAdvancedPaymentForm(prev => ({ ...prev, walletId: e.target.value }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500"
                    >
                       <option value="">اختر المحفظة</option>
{wallets.map(wallet => (
    <option key={wallet.id} value={wallet.id}>
        {wallet.name} - {wallet.balance} {getCurrencySymbol(wallet.currency)}
    </option>
))}
                    </select>
                </div>
                
                {/* ملاحظات */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        ملاحظات
                    </label>
                    <textarea
                        value={advancedPaymentForm.notes}
                        onChange={(e) => setAdvancedPaymentForm(prev => ({ ...prev, notes: e.target.value }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-green-500"
                        rows="3"
                        placeholder="أضف ملاحظات حول العملية..."
                    />
                </div>
                
                <div className="flex gap-3 pt-4">
                    <button
                        onClick={() => setShowAdvancedPaymentModal(false)}
                        className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                        إلغاء
                    </button>
                    <button
                        onClick={processAdvancedPayment}
                        disabled={isLoading}
                        className={`flex-1 px-4 py-3 text-white rounded-lg flex items-center justify-center gap-2 ${
                            advancedPaymentForm.paymentType === 'payment' ? 'bg-green-600 hover:bg-green-700' :
                            advancedPaymentForm.paymentType === 'refund' ? 'bg-red-600 hover:bg-red-700' :
                            'bg-gray-600 hover:bg-gray-700'
                        } disabled:opacity-50`}
                    >
                        {isLoading ? <RefreshCw className="animate-spin" size={16} /> : 
                         advancedPaymentForm.paymentType === 'payment' ? <ArrowUpCircle size={16} /> :
                         advancedPaymentForm.paymentType === 'refund' ? <ArrowDownCircle size={16} /> :
                         <X size={16} />}
                        {advancedPaymentForm.paymentType === 'payment' ? 'تأكيد الدفع' :
                         advancedPaymentForm.paymentType === 'refund' ? 'تأكيد الاسترداد' :
                         'تأكيد الإلغاء'}
                    </button>
                </div>
            </div>
        </div>
    </div>
)}






{/* نافذة إدارة المحافظ */}
{showWalletManagementModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-y-auto">
            <div className="bg-purple-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold">🏦 إدارة المحافظ والخزائن</h3>
                    <button
                        onClick={() => setShowWalletManagementModal(false)}
                        className="text-white hover:bg-purple-700 p-2 rounded-full"
                    >
                        <X size={20} />
                    </button>
                </div>
            </div>
            
            <div className="p-6">
                {/* إضافة محفظة جديدة */}
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <h4 className="font-medium text-gray-800 mb-4">إضافة محفظة جديدة</h4>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                اسم المحفظة
                            </label>
                            <input
                                type="text"
                                value={newWalletForm.name}
                                onChange={(e) => setNewWalletForm(prev => ({ ...prev, name: e.target.value }))}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500"
                                placeholder="مثال: صندوق المكتب"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                العملة
                            </label>
                            <select
                                value={newWalletForm.currency}
                                onChange={(e) => setNewWalletForm(prev => ({ ...prev, currency: e.target.value }))}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500"
                            >
                                <option value="EGP">🇪🇬 جنيه مصري (ج.م)</option>
                                <option value="SAR">🇸🇦 ريال سعودي (ر.س)</option>
                                <option value="USD">🇺🇸 دولار أمريكي ($)</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                النوع
                            </label>
                            <select
                                value={newWalletForm.type}
                                onChange={(e) => setNewWalletForm(prev => ({ ...prev, type: e.target.value }))}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500"
                            >
                                <option value="cash">💰 نقدي</option>
                                <option value="mobile">📱 محفظة إلكترونية</option>
                                <option value="bank">🏦 حساب بنكي</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                الرصيد الابتدائي
                            </label>
                            <input
                                type="number"
                                value={newWalletForm.balance}
                                onChange={(e) => setNewWalletForm(prev => ({ ...prev, balance: Number(e.target.value) }))}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-500"
                                placeholder="0"
                            />
                        </div>
                    </div>
                    <button
                        onClick={addWallet}
                        disabled={isLoading || !newWalletForm.name.trim()}
                        className="mt-4 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 disabled:opacity-50 flex items-center gap-2"
                    >
                        {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <Plus size={16} />}
                        إضافة المحفظة
                    </button>
                </div>
                
                {/* المحافظ الحالية */}
                <div>
                   <div className="flex justify-between items-center mb-4">
    <h4 className="font-medium text-gray-800">المحافظ والخزائن الحالية</h4>
 
</div>
                    
                    {/* إحصائيات سريعة */}
                    {financialStats.wallets && (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                            {financialStats.wallets.map(stat => (
                                <div key={stat.currency} className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-4 border border-purple-200">
                                    <div className="text-center">
                                        <div className="text-2xl font-bold text-purple-700">
                                            {stat.totalBalance} {getCurrencySymbol(stat.currency)}
                                        </div>
                                        <div className="text-sm text-purple-600">
                                            إجمالي {getCurrencyName(stat.currency)} ({stat.walletCount} محفظة)
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    {wallets.map(wallet => (
        <div key={wallet.id} className={`border rounded-lg p-4 hover:shadow-lg transition-shadow relative group ${
    wallet.isActive === 0 ? 'border-red-200 bg-red-50' : 'border-gray-200'
}`}>            {/* زر الحذف */}
            <button
                onClick={() => deleteWallet(wallet.id, wallet.name)}
                className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 bg-red-100 hover:bg-red-200 text-red-600 p-1.5 rounded-full transition-all duration-200 hover:scale-110"
                title="حذف المحفظة"
            >
                <Trash2 size={16} />
            </button>
            
            <div className="flex items-center justify-between mb-3">
                <div className={`p-2 rounded-lg ${
                    wallet.type === 'cash' ? 'bg-green-100 text-green-600' :
                    wallet.type === 'mobile' ? 'bg-blue-100 text-blue-600' :
                    'bg-purple-100 text-purple-600'
                }`}>
                    {wallet.type === 'cash' ? <Wallet size={20} /> :
                     wallet.type === 'mobile' ? <Smartphone size={20} /> :
                     <Building size={20} />}
                </div>
                <div className="text-right">
                    <div className="text-lg font-bold text-gray-900">
                        {wallet.balance} {getCurrencySymbol(wallet.currency)}
                    </div>
                    <div className="text-xs text-gray-500">الرصيد الحالي</div>
                </div>
            </div>
            
            <div className="space-y-2">
                <div className="font-medium text-gray-900">{wallet.name}</div>
                <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">
                        {getCurrencyName(wallet.currency)}
                    </span>
                    <span className={`px-2 py-1 rounded text-xs ${
                        wallet.type === 'cash' ? 'bg-green-50 text-green-700' :
                        wallet.type === 'mobile' ? 'bg-blue-50 text-blue-700' :
                        'bg-purple-50 text-purple-700'
                    }`}>
                        {wallet.type === 'cash' ? 'نقدي' :
                         wallet.type === 'mobile' ? 'إلكتروني' :
                         'بنكي'}
                    </span>
                </div>
            </div>
            
    <div className="mt-4 pt-3 border-t border-gray-200 flex gap-2">
    <button
        onClick={() => {
            setSelectedWallet(wallet);
            setInternalTransactionForm(prev => ({ ...prev, walletId: wallet.id }));
            setShowInternalTransactionModal(true);
            setShowWalletManagementModal(false);
        }}
        className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-3 rounded text-sm transition-colors"
    >
        إجراء معاملة
    </button>
    <button
        onClick={() => deleteWallet(wallet.id, wallet.name)}
        className="bg-red-100 hover:bg-red-200 text-red-600 p-2 rounded transition-colors"
        title="حذف المحفظة نهائياً"
    >
        <Trash2 size={16} />
    </button>
    <button
        onClick={() => {
            fetchFinancialTransactions({ walletId: wallet.id });
            setShowFinancialReportModal(true);
            setShowWalletManagementModal(false);
        }}
        className="bg-blue-100 hover:bg-blue-200 text-blue-700 py-2 px-3 rounded text-sm transition-colors"
        title="عرض معاملات هذه المحفظة"
    >
        <Eye size={16} />
    </button>
</div>
        </div>
    ))}
</div>
                </div>
            </div>
        </div>
    </div>
)}

{/* نافذة المعاملة الداخلية */}
{showInternalTransactionModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="bg-orange-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold">💸 معاملة داخلية</h3>
                    <button
                        onClick={() => setShowInternalTransactionModal(false)}
                        className="text-white hover:bg-orange-700 p-2 rounded-full"
                    >
                        <X size={20} />
                    </button>
                </div>
                <p className="text-orange-100 mt-2">إيداع أو سحب داخلي</p>
            </div>
            
            <div className="p-6 space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        المحفظة
                    </label>
                    <select
                        value={internalTransactionForm.walletId}
                        onChange={(e) => setInternalTransactionForm(prev => ({ ...prev, walletId: e.target.value }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-orange-500"
                    >
                        <option value="">اختر المحفظة</option>
                        {wallets.map(wallet => (
                            <option key={wallet.id} value={wallet.id}>
                                {wallet.name} - {wallet.balance} {getCurrencySymbol(wallet.currency)}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        نوع المعاملة
                    </label>
                    <select
                        value={internalTransactionForm.transactionType}
                        onChange={(e) => setInternalTransactionForm(prev => ({ ...prev, transactionType: e.target.value }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-orange-500"
                    >
                        <option value="deposit">📈 إيداع (إضافة للرصيد)</option>
                        <option value="withdraw">📉 سحب (خصم من الرصيد)</option>
                    </select>
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        المبلغ
                    </label>
                    <input
                        type="number"
                        value={internalTransactionForm.amount}
                        onChange={(e) => setInternalTransactionForm(prev => ({ ...prev, amount: Number(e.target.value) }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-orange-500"
                        placeholder="أدخل المبلغ..."
                        min="0"
                    />
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        وصف المعاملة
                    </label>
                    <textarea
                        value={internalTransactionForm.description}
                        onChange={(e) => setInternalTransactionForm(prev => ({ ...prev, description: e.target.value }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-orange-500"
                        rows="3"
                        placeholder="مثال: إيداع نقدي، سحب مصروفات، تحويل من حساب آخر..."
                    />
                </div>
                
                <div className="flex gap-3 pt-4">
                    <button
                        onClick={() => setShowInternalTransactionModal(false)}
                        className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                        إلغاء
                    </button>
                    <button
                        onClick={processInternalTransaction}
                        disabled={isLoading}
                        className="flex-1 px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <Calculator size={16} />}
                        تنفيذ المعاملة
                    </button>
                </div>
            </div>
        </div>
    </div>
)}








{/* نافذة التقرير المالي */}
{showFinancialReportModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl max-h-[95vh] overflow-y-auto">
            <div className="bg-indigo-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold">📊 التقرير المالي الشامل</h3>
                    <button
                        onClick={() => setShowFinancialReportModal(false)}
                        className="text-white hover:bg-indigo-700 p-2 rounded-full"
                    >
                        <X size={20} />
                    </button>
                </div>
                <p className="text-indigo-100 mt-2">سجل المعاملات والإحصائيات المالية</p>
            </div>
            
            <div className="p-6">
                {/* فلاتر التقرير المحسنة */}
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <h4 className="font-medium text-gray-800 mb-4">فلترة وبحث المعاملات</h4>
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">المحفظة</label>
                            <select
                                value={transactionFilters.walletId}
                                onChange={(e) => {
                                    setTransactionFilters(prev => ({ ...prev, walletId: e.target.value }));
                                    fetchFinancialTransactions({ walletId: e.target.value }, 1, false);
                                }}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                            >
                                <option value="">جميع المحافظ</option>
                                {wallets.map(wallet => (
                                    <option key={wallet.id} value={wallet.id}>
                                        {wallet.name} ({getCurrencySymbol(wallet.currency)})
                                    </option>
                                ))}
                            </select>
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">من تاريخ</label>
                            <input
                                type="date"
                                value={transactionFilters.startDate}
                                onChange={(e) => {
                                    setTransactionFilters(prev => ({ ...prev, startDate: e.target.value }));
                                    fetchFinancialTransactions({ startDate: e.target.value }, 1, false);
                                }}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">إلى تاريخ</label>
                            <input
                                type="date"
                                value={transactionFilters.endDate}
                                onChange={(e) => {
                                    setTransactionFilters(prev => ({ ...prev, endDate: e.target.value }));
                                    fetchFinancialTransactions({ endDate: e.target.value }, 1, false);
                                }}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">إعادة تعيين</label>
                            <button
                                onClick={() => {
                                    setTransactionFilters({ startDate: '', endDate: '', walletId: '' });
                                    fetchFinancialTransactions({}, 1, false);
                                }}
                                className="w-full bg-gray-600 text-white py-2 px-4 rounded-lg hover:bg-gray-700"
                            >
                                🔄 مسح الفلاتر
                            </button>
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">تحديث</label>
                            <button
                                onClick={() => fetchFinancialTransactions({}, 1, false)}
                                className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700"
                            >
                                📊 تحديث القائمة
                            </button>
                        </div>
                    </div>
                </div>

                {/* الإحصائيات المالية */}
                {financialStats && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                        {/* إجمالي الأرصدة */}
                        <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 border border-green-200">
                            <div className="flex items-center justify-between mb-4">
                                <h5 className="font-bold text-green-800">💰 الأرصدة الحالية</h5>
                                <TrendingUp className="text-green-600" size={24} />
                            </div>
                           {financialStats.wallets && financialStats.wallets.map((stat, index) => (
    <div key={`wallet-${stat.currency}-${index}`} className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-4 border border-purple-200">
                                    <span className="text-green-700 font-medium">{getCurrencyName(stat.currency)}</span>
                                    <span className="text-green-800 font-bold">{stat.totalBalance} {getCurrencySymbol(stat.currency)}</span>
                                </div>
                            ))}
                        </div>

                        {/* إجمالي الإيرادات */}
                        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
                            <div className="flex items-center justify-between mb-4">
                                <h5 className="font-bold text-blue-800">📈 إجمالي الإيرادات</h5>
                                <ArrowUpCircle className="text-blue-600" size={24} />
                            </div>
                           {financialStats.revenue && financialStats.revenue.map((stat, index) => (
    <div key={`revenue-${stat.currency}-${index}`} className="flex justify-between items-center py-2 border-b border-blue-200 last:border-b-0">
                                    <span className="text-blue-700 font-medium">{getCurrencyName(stat.currency)}</span>
                                    <span className="text-blue-800 font-bold">+{stat.revenue} {getCurrencySymbol(stat.currency)}</span>
                                </div>
                            ))}
                        </div>

                        {/* إجمالي المستردات */}
                        <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-6 border border-red-200">
                            <div className="flex items-center justify-between mb-4">
                                <h5 className="font-bold text-red-800">📉 إجمالي المستردات</h5>
                                <ArrowDownCircle className="text-red-600" size={24} />
                            </div>
                           {financialStats.refunds && financialStats.refunds.map((stat, index) => (
    <div key={`refunds-${stat.currency}-${index}`} className="flex justify-between items-center py-2 border-b border-red-200 last:border-b-0">
                                    <span className="text-red-700 font-medium">{getCurrencyName(stat.currency)}</span>
                                    <span className="text-red-800 font-bold">-{stat.refunds} {getCurrencySymbol(stat.currency)}</span>
                                </div>
                            ))}
                        </div>

                        {/* معاملات اليوم */}
                        <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border border-purple-200 md:col-span-3">
                            <div className="flex items-center justify-between mb-4">
                                <h5 className="font-bold text-purple-800">🕒 معاملات اليوم</h5>
                                <Clock className="text-purple-600" size={24} />
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                               {financialStats.today && financialStats.today.map((stat, index) => (
    <div key={`today-${stat.currency}-${index}`} className="bg-white rounded-lg p-4 border border-purple-200">
                                        <div className="text-center">
                                            <div className="text-lg font-bold text-purple-800 mb-2">
                                                {getCurrencyName(stat.currency)}
                                            </div>
                                            <div className="space-y-2">
                                                <div className="flex justify-between">
                                                    <span className="text-purple-600">إيرادات:</span>
                                                    <span className="text-green-600 font-bold">+{stat.todayIncome} {getCurrencySymbol(stat.currency)}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-purple-600">مصروفات:</span>
                                                    <span className="text-red-600 font-bold">-{stat.todayOutcome} {getCurrencySymbol(stat.currency)}</span>
                                                </div>
                                                <div className="flex justify-between pt-2 border-t border-purple-200">
                                                    <span className="text-purple-700 font-medium">المعاملات:</span>
                                                    <span className="text-purple-800 font-bold">{stat.todayCount}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* سجل المعاملات */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
                        <div className="flex justify-between items-center">
                            <h5 className="font-bold text-gray-800 flex items-center gap-2">
                                <Receipt size={20} />
                                سجل المعاملات المالية
                            </h5>
                            <div className="text-sm text-blue-600 bg-blue-50 px-3 py-1 rounded-full border border-blue-200">
                                📊 عرض حسب الفلاتر المحددة
                            </div>
                        </div>
                        <p className="text-sm text-gray-600 mt-1">
                            يتم عرض المعاملات مرتبة حسب التاريخ (الأحدث أولاً)
                        </p>
                    </div>
                    
                    {financialTransactions.length > 0 ? (
                        <div className="overflow-x-auto">
                            <table className="w-full">
<thead className="bg-gray-50">
    <tr>
        <th className="px-4 py-3 text-right font-medium text-gray-700">التاريخ</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">المحفظة</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">نوع المعاملة</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">المبلغ</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">العميل</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">الوصف</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">بواسطة</th>
        <th className="px-4 py-3 text-right font-medium text-gray-700">الإجراءات</th>
    </tr>
</thead>
                     <tbody className="divide-y divide-gray-200">
    {financialTransactions.map((transaction, index) => (
        <tr key={transaction.TransactionID || index} className="hover:bg-gray-50 group">
            {/* التاريخ */}
            <td className="px-4 py-3 text-sm text-gray-600">
                {new Date(transaction.CreatedAt).toLocaleString('ar-EG')}
            </td>
            
            {/* المحفظة */}
            <td className="px-4 py-3">
                <div className="flex items-center gap-2">
                    <span className="font-medium text-gray-900">{transaction.WalletName}</span>
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                        {getCurrencySymbol(transaction.WalletCurrency)}
                    </span>
                </div>
            </td>
            
            {/* نوع المعاملة */}
            <td className="px-4 py-3">
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    transaction.TransactionType === 'payment' ? 'bg-green-50 text-green-700' :
                    transaction.TransactionType === 'refund' ? 'bg-red-50 text-red-700' :
                    transaction.TransactionType === 'deposit' ? 'bg-blue-50 text-blue-700' :
                    transaction.TransactionType === 'withdraw' ? 'bg-orange-50 text-orange-700' :
                    transaction.TransactionType === 'cancel' ? 'bg-gray-50 text-gray-700' :
                    'bg-purple-50 text-purple-700'
                }`}>
                    {transaction.TransactionTypeDisplay}
                </span>
            </td>
            
            {/* المبلغ */}
            <td className="px-4 py-3">
                <div className={`font-bold text-lg ${
                    transaction.Amount > 0 ? 'text-green-600' : 
                    transaction.Amount < 0 ? 'text-red-600' : 
                    'text-gray-600'
                }`}>
                    {transaction.Amount > 0 ? '+' : ''}{transaction.Amount} {getCurrencySymbol(transaction.WalletCurrency)}
                </div>
                <div className="text-xs text-gray-500">
                    {transaction.AmountDirection}
                </div>
            </td>
            
            {/* العميل */}
            <td className="px-4 py-3">
                {transaction.ClientName ? (
                    <div>
                        <div className="font-medium text-gray-900">{transaction.ClientName}</div>
                        <div className="text-xs text-gray-500">{transaction.ClientPassportNumber}</div>
                        {transaction.ClientCompany && (
                            <div className="text-xs text-blue-600">{transaction.ClientCompany}</div>
                        )}
                    </div>
                ) : (
                    <span className="text-gray-400 italic">معاملة داخلية</span>
                )}
            </td>
            
            {/* الوصف */}
            <td className="px-4 py-3">
                <div className="max-w-xs">
                    <div className="text-sm text-gray-900">{transaction.Description}</div>
                    {transaction.Notes && (
                        <div className="text-xs text-gray-500 mt-1 bg-gray-50 p-2 rounded">
                            💬 {transaction.Notes}
                        </div>
                    )}
                </div>
            </td>
            
            {/* بواسطة */}
            <td className="px-4 py-3 text-sm text-gray-600">
                <div>{transaction.ProcessedBy}</div>
                <div className="text-xs text-gray-400">
                    {new Date(transaction.CreatedAt).toLocaleDateString('ar-EG')}
                </div>
            </td>
            
            {/* الإجراءات */}
            <td className="px-4 py-3">
                <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    {['deposit', 'withdraw'].includes(transaction.TransactionType) && (
                        <button
                            onClick={() => editTransaction(transaction)}
                            className="bg-blue-100 hover:bg-blue-200 text-blue-600 p-2 rounded-lg transition-colors"
                            title="تعديل المعاملة"
                        >
                            <Edit3 size={16} />
                        </button>
                    )}
                    
                    {transaction.TransactionType !== 'reverse_delete' && (
                        <button
                            onClick={() => deleteTransaction(transaction.TransactionID, transaction.Description)}
                            className="bg-red-100 hover:bg-red-200 text-red-600 p-2 rounded-lg transition-colors"
                            title="حذف المعاملة"
                        >
                            <Trash2 size={16} />
                        </button>
                    )}
                    
                    <button
                        onClick={() => {
                            alert(`تفاصيل المعاملة:\n\nالرقم: ${transaction.TransactionID}\nالنوع: ${transaction.TransactionTypeDisplay}\nالمحفظة: ${transaction.WalletName}\nالمبلغ: ${transaction.Amount} ${getCurrencySymbol(transaction.WalletCurrency)}\nالعميل: ${transaction.ClientName || 'معاملة داخلية'}\nالوصف: ${transaction.Description}\nالملاحظات: ${transaction.Notes || 'لا توجد'}\nتمت بواسطة: ${transaction.ProcessedBy}\nالتاريخ: ${new Date(transaction.CreatedAt).toLocaleString('ar-EG')}`);
                        }}
                        className="bg-gray-100 hover:bg-gray-200 text-gray-600 p-2 rounded-lg transition-colors"
                        title="عرض التفاصيل"
                    >
                        <Eye size={16} />
                    </button>
                </div>
            </td>
        </tr>
    ))}
</tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-center py-12">
                            <Receipt className="mx-auto h-16 w-16 text-gray-400 mb-4" />
                            <h3 className="text-lg font-medium text-gray-900 mb-2">لا توجد معاملات</h3>
                            <p className="text-gray-600">ستظهر هنا المعاملات المالية حسب الفلاتر المحددة</p>
                        </div>
                    )}
                </div>

                {/* معلومات Pagination وزر عرض المزيد */}
                {financialTransactions.length > 0 && (
                    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 rounded-b-lg mt-4">
                        <div className="flex justify-between items-center">
                            <div className="text-sm text-gray-600">
                                عرض {currentPage === 1 ? 1 : ((currentPage - 1) * 20) + 1} - {Math.min(currentPage * 20, totalTransactions)} من إجمالي {totalTransactions} معاملة
                                <br />
                                <span className="text-xs text-gray-500">
                                    الصفحة {currentPage} من {totalPages}
                                </span>
                            </div>
                            
                            <div className="flex gap-3">
                                {hasMoreTransactions && (
                                    <button
                                        onClick={() => fetchFinancialTransactions({}, currentPage + 1, true)}
                                        className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 flex items-center gap-2"
                                    >
                                        <ArrowDownCircle size={16} />
                                        تحميل المزيد (20 معاملة)
                                    </button>
                                )}
                                
                                {currentPage > 1 && (
                                    <button
                                        onClick={() => fetchFinancialTransactions({}, 1, false)}
                                        className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 flex items-center gap-2"
                                    >
                                        <RefreshCw size={16} />
                                        العودة للأول
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
)}






            {/* Notes Modal */}
            {showNotesModal && selectedPassport && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
                        <div className="bg-blue-600 text-white p-6 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <h3 className="text-xl font-bold">📝 إضافة ملاحظة</h3>
                                <button
                                    onClick={() => setShowNotesModal(false)}
                                    className="text-white hover:bg-blue-700 p-2 rounded-full"
                                >
                                    <X size={20} />
                                </button>
                            </div>
                            <p className="text-blue-100 mt-2">{selectedPassport.NameArabic}</p>
                        </div>
                        
                        <div className="p-6 space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    ملاحظة قسم التأشيرات
                                </label>
                                <textarea
                                    value={visaNotesForm}
                                    onChange={(e) => setVisaNotesForm(e.target.value)}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500"
                                    rows="4"
                                    placeholder="أضف ملاحظة خاصة بقسم التأشيرات..."
                                />
                            </div>
                            
                            {selectedPassport.VisaNotes && (
                                <div className="bg-gray-50 rounded-lg p-4">
                                    <h4 className="font-medium text-gray-700 mb-2">الملاحظات السابقة:</h4>
                                    <p className="text-gray-600 text-sm">{selectedPassport.VisaNotes}</p>
                                </div>
                            )}
                            
                            <div className="flex gap-3 pt-4">
                                <button
                                    onClick={() => setShowNotesModal(false)}
                                    className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                                >
                                    إلغاء
                                </button>
                                <button
                                    onClick={addVisaNotes}
                                    disabled={isLoading || !visaNotesForm.trim()}
                                    className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center gap-2"
                                >
                                    {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <Save size={16} />}
                                    حفظ الملاحظة
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

       
            {/* Payment Methods Modal */}
            {showPaymentMethodsModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                        <div className="bg-blue-600 text-white p-6 rounded-t-2xl">
                            <div className="flex justify-between items-center">
                                <h3 className="text-xl font-bold">🏦 إدارة طرق الدفع</h3>
                                <button
                                    onClick={() => setShowPaymentMethodsModal(false)}
                                    className="text-white hover:bg-blue-700 p-2 rounded-full"
                                >
                                    <X size={20} />
                                </button>
                            </div>
                        </div>
                        
                        <div className="p-6">
                            {/* Add New Payment Method */}
                            <div className="bg-gray-50 rounded-lg p-4 mb-6">
                                <h4 className="font-medium text-gray-800 mb-4">إضافة طريقة دفع جديدة</h4>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            اسم طريقة الدفع
                                        </label>
                                        <input
                                            type="text"
                                            value={newPaymentMethod.name}
                                            onChange={(e) => setNewPaymentMethod(prev => ({ ...prev, name: e.target.value }))}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                            placeholder="مثال: فودافون كاش"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            نوع الحساب
                                        </label>
                                        <select
                                            value={newPaymentMethod.type}
                                            onChange={(e) => setNewPaymentMethod(prev => ({ ...prev, type: e.target.value }))}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="cash">نقدي</option>
                                            <option value="mobile">محافظ إلكترونية</option>
                                            <option value="bank">حساب بنكي</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            الرصيد الابتدائي
                                        </label>
                                        <input
                                            type="number"
                                            value={newPaymentMethod.balance}
                                            onChange={(e) => setNewPaymentMethod(prev => ({ ...prev, balance: Number(e.target.value) }))}
                                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                            placeholder="0"
                                        />
                                    </div>
                                </div>
                                <button
                                   disabled={isLoading || !newPaymentMethod.name.trim()}
                                    className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2"
                                >
                                    {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <Plus size={16} />}
                                    إضافة طريقة الدفع
                                </button>
                            </div>
                            
                            {/* Current Payment Methods */}
                            <div>
                                <h4 className="font-medium text-gray-800 mb-4">طرق الدفع الحالية</h4>
                                <div className="space-y-3">
                          {wallets.map(wallet => (
    <div key={wallet.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
        <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${
                wallet.type === 'cash' ? 'bg-green-100 text-green-600' :
                wallet.type === 'mobile' ? 'bg-blue-100 text-blue-600' :
                'bg-purple-100 text-purple-600'
            }`}>
                {wallet.type === 'cash' ? <Wallet size={20} /> :
                 wallet.type === 'mobile' ? <Smartphone size={20} /> :
                 <Building size={20} />}
            </div>
            <div>
                <div className="font-medium text-gray-900">{wallet.name}</div>
                <div className="text-sm text-gray-600">
                    {wallet.type === 'cash' ? 'نقدي' :
                     wallet.type === 'mobile' ? 'محفظة إلكترونية' :
                     'حساب بنكي'}
                </div>
            </div>
        </div>
        <div className="text-right">
            <div className="font-bold text-lg text-gray-900">
                {wallet.balance} {getCurrencySymbol(wallet.currency)}
            </div>
            <div className="text-sm text-gray-600">الرصيد الحالي</div>
        </div>
    </div>
))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

                 {/* Notifications Modal */}
                 {showNotificationsModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                  <div className="bg-red-600 text-white p-6 rounded-t-2xl">
    <div className="flex justify-between items-center">
        <div>
            <h3 className="text-xl font-bold">🔔 الإشعارات الجديدة</h3>
            <p className="text-red-100 mt-2">إشعارات التأكيدات الجديدة من قسم الجوازات</p>
            <p className="text-red-200 text-xs mt-1">
                📅 الحذف التلقائي: بعد 24 ساعة من الإنشاء
            </p>
        </div>
        <div className="flex gap-2">
            {/* زر التنظيف التلقائي اليدوي */}
            <button
                onClick={triggerAutoCleanup}
                className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-lg flex items-center gap-2"
                title="تنظيف الإشعارات القديمة (أقدم من 24 ساعة)"
            >
                <Clock size={16} />
                تنظيف تلقائي
            </button>
            
            {/* زر مسح الكل */}
            {notifications.length > 0 && (
                <button
                    onClick={clearAllNotifications}
                    disabled={isLoading}
                    className="bg-red-800 hover:bg-red-900 text-white px-3 py-2 rounded-lg flex items-center gap-2 disabled:opacity-50"
                    title="مسح جميع الإشعارات نهائياً"
                >
                    {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <Trash2 size={16} />}
                    مسح الكل
                </button>
            )}
            
            {/* زر الإغلاق */}
            <button
                onClick={() => setShowNotificationsModal(false)}
                className="text-white hover:bg-red-700 p-2 rounded-full"
            >
                <X size={20} />
            </button>
        </div>
    </div>
</div>
                        
                        <div className="p-6">
                            {notifications.length > 0 ? (
                                <div className="space-y-4">
                                    {notifications.map(notification => (
                                        <div key={notification.NotificationID} 
                                             className={`p-4 rounded-lg border-r-4 ${
                                                 notification.IsRead 
                                                     ? 'bg-gray-50 border-gray-300' 
                                                     : 'bg-blue-50 border-blue-500'
                                             }`}>
                                            <div className="flex justify-between items-start">
                                                <div className="flex-1">
                                                    <div className="font-bold text-lg text-gray-900 mb-2">
                                                        ✅ تم تأكيد: {notification.PassportName}
                                                    </div>
                                                    <div className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                                                        <div><strong>رقم الجواز:</strong> {notification.PassportNumber}</div>
                                                        <div><strong>الشركة:</strong> {notification.CompanyName}</div>
                                                        <div><strong>المندوب:</strong> {notification.DelegateName}</div>
                                                        <div><strong>المهنة:</strong> {notification.ProfessionName}</div>
                                                        <div><strong>الهاتف:</strong> {notification.PhoneNumbers}</div>
                                                        <div><strong>القائمة:</strong> {notification.ListName}</div>
                                                    </div>
                                                    <div className="mt-3 text-xs text-gray-500">
                                                        تم التأكيد: {new Date(notification.ConfirmedAt).toLocaleString('ar-EG')} 
                                                        بواسطة {notification.ConfirmedBy}
                                                    </div>
                                                </div>
                                         <div className="flex gap-2">
    {!notification.IsRead && (
        <button
            onClick={() => markAsRead(notification.NotificationID)}
            className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
        >
            تم القراءة
        </button>
    )}
    <button
        onClick={() => deleteNotification(notification.NotificationID)}
        className="bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700 flex items-center gap-1"
        title="حذف هذا الإشعار نهائياً"
    >
        <Trash2 size={14} />
        حذف
    </button>
</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-8">
                                    <Bell className="mx-auto h-16 w-16 text-gray-400 mb-4" />
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">لا توجد إشعارات</h3>
                                    <p className="text-gray-600">ستظهر هنا الإشعارات الجديدة</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}




{/* نافذة عرض الملاحظات الكاملة */}
{showFullNotesModal && selectedNotesPassport && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <div>
                        <h3 className="text-xl font-bold">📋 ملاحظات مفصلة</h3>
                        <p className="text-blue-100 mt-1">{selectedNotesPassport.NameArabic}</p>
                        <p className="text-blue-200 text-sm">رقم الجواز: {selectedNotesPassport.PassportID}</p>
                    </div>
                    <button
                        onClick={() => setShowFullNotesModal(false)}
                        className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
                    >
                        <X size={24} />
                    </button>
                </div>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-[60vh]">

              <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-4 mb-6">
        <h4 className="font-bold text-gray-800 text-lg mb-4 flex items-center gap-2">
            📸 الصور المرفقة
        </h4>
<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    <div className="text-center">
        <div className="mb-2">
            <ImageViewer 
                src={selectedNotesPassport.PersonalImage} 
                alt={`الصورة الشخصية لـ ${selectedNotesPassport.NameArabic}`}
                type="personal"
                personName={selectedNotesPassport.NameArabic}
            />
        </div>
        <span className="text-sm text-gray-600 font-medium">الصورة الشخصية</span>
    </div>
    <div className="text-center">
        <div className="mb-2">
            <ImageViewer 
                src={selectedNotesPassport.PassportImage} 
                alt={`صورة جواز ${selectedNotesPassport.NameArabic}`}
                type="passport"
                personName={selectedNotesPassport.NameArabic}
            />
        </div>
        <span className="text-sm text-gray-600 font-medium">صورة الجواز</span>
    </div>
    <div className="text-center">
        <div className="mb-2">
            <ImageViewer 
                src={selectedNotesPassport.LicenseImage} 
                alt={`صورة رخصة ${selectedNotesPassport.NameArabic}`}
                type="license"
                personName={selectedNotesPassport.NameArabic}
            />
        </div>
        <span className="text-sm text-gray-600 font-medium">صورة الرخصة</span>
    </div>
    <div className="text-center">
        <div className="mb-2">
            <ImageViewer 
                src={selectedNotesPassport.IDImage} 
                alt={`صورة البطاقة ${selectedNotesPassport.NameArabic}`}
                type="id"
                personName={selectedNotesPassport.NameArabic}
            />
        </div>
        <span className="text-sm text-gray-600 font-medium">صورة البطاقة</span>
    </div>
</div>
    </div>
    


                <div className="space-y-4">
                    {selectedNotesPassport.CombinedNotes ? (
                        (() => {
                            const cleanedNotes = cleanNotesData(selectedNotesPassport.CombinedNotes);

                            const parts = selectedNotesPassport.CombinedNotes.split('--- ملاحظات قسم التأشيرات ---');
                            return (
                                <div className="space-y-6">
                                    {/* الملاحظات الأصلية - غير قابلة للحذف */}
                                    {parts[0] && parts[0].trim() && (
                                        <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-r-4 border-gray-400 rounded-xl p-4 shadow-sm">
                                            <div className="flex items-center gap-3 mb-3">
                                                <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
                                                <h4 className="font-bold text-gray-800 text-lg">📝 الملاحظات الأصلية</h4>
                                                <span className="bg-gray-200 text-gray-600 px-2 py-1 rounded-full text-xs">
                                                    محمية
                                                </span>
                                            </div>
                                            <div className="text-gray-700 leading-relaxed">
                                                {getNotesText(parts[0].trim()).split('\n').map((line, index) => (
                                                    line.trim() && (
                                                        <div key={index} className="mb-2 p-3 bg-white rounded-lg shadow-sm border border-gray-200">
                                                            <div className="flex items-center justify-between">
                                                                <span className="flex-1">{line.trim()}</span>
                                                                <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">
                                                                    🔒 محمية
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* ملاحظات التأشيرات - قابلة للحذف */}
                                    {parts[1] && parts[1].trim() && (
                                        <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-r-4 border-blue-400 rounded-xl p-4 shadow-sm">
                                            <div className="flex items-center gap-3 mb-3">
                                                <div className="w-3 h-3 bg-blue-400 rounded-full animate-pulse"></div>
                                                <h4 className="font-bold text-blue-800 text-lg">💼 ملاحظات قسم التأشيرات</h4>
                                                <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                                                    قابلة للتعديل
                                                </span>
                                            </div>
                                            <div className="text-blue-700 leading-relaxed">
                                                {getNotesText(parts[1].trim()).split('\n').map((line, index) => (
                                                    line.trim() && (
                                                        <div key={`visa-note-${index}`} className="mb-2 p-3 bg-white rounded-lg shadow-sm border border-blue-200 group hover:border-red-300 transition-colors">
                                                            <div className="flex items-center justify-between gap-3">
                                                                <span className="flex-1">{line.trim()}</span>
                                                                <div className="flex items-center gap-2">
                                                                    <span className="text-xs text-blue-500 bg-blue-100 px-2 py-1 rounded">
                                                                        التأشيرات
                                                                    </span>
                                                                    <button
    onClick={() => handleDeleteVisaNote(selectedNotesPassport.PassportID, line.trim(), index)}
    className="opacity-0 group-hover:opacity-100 bg-red-100 hover:bg-red-200 text-red-600 p-1.5 rounded-full transition-all duration-200 hover:scale-110 hover:shadow-md"
    title="حذف نهائي من كلا النظامين"
>
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })()
                    ) : (
                        <div className="text-center py-8">
                            <div className="text-gray-400 text-6xl mb-4">📝</div>
                            <p className="text-gray-600">لا توجد ملاحظات متاحة</p>
                        </div>
                    )}
                </div>
            </div>
            
            <div className="bg-gray-50 px-6 py-4 rounded-b-2xl border-t flex gap-3">
                <button
                    onClick={() => setShowFullNotesModal(false)}
                    className="flex-1 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white px-6 py-3 rounded-lg transition-colors"
                >
                    إغلاق
                </button>
                <button
                    onClick={() => {
                        setSelectedPassport(selectedNotesPassport);
                        setShowNotesModal(true);
                        setShowFullNotesModal(false);
                    }}
                    className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 py-3 rounded-lg transition-colors flex items-center gap-2"
                >
                    <Plus size={18} />
                    إضافة ملاحظة جديدة
                </button>
            </div>
        </div>
    </div>
)}



{/* Remove Modal */}
{showRemoveModal && selectedPassport && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="bg-orange-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold">🔄 إلغاء التأكيد</h3>
                    <button
                        onClick={() => setShowRemoveModal(false)}
                        className="text-white hover:bg-orange-700 p-2 rounded-full"
                    >
                        <X size={20} />
                    </button>
                </div>
                <p className="text-orange-100 mt-2">{selectedPassport.NameArabic}</p>
                <p className="text-orange-200 text-sm">سيتم إرجاعه لقائمة المتاحين في صفحة الجوازات</p>
            </div>
            
            <div className="p-6 space-y-4">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div className="flex items-center gap-2 text-blue-800">
                        <RefreshCw size={20} />
                        <span className="font-medium">إلغاء التأكيد</span>
                    </div>
                    <p className="text-blue-700 text-sm mt-2">
                        سيتم إلغاء تأكيد هذا الشخص وإرجاعه لحالة "متاح للاختيار" في صفحة الجوازات
                    </p>
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        سبب الإلغاء (اختياري)
                    </label>
                    <textarea
                        value={removeReason}
                        onChange={(e) => setRemoveReason(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-orange-500"
                        rows="3"
                        placeholder="مثال: عدم اكتمال الأوراق، تغيير في القرار، أخطاء في البيانات... (اتركه فارغاً لإلغاء التأكيد فقط)"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        💡 إذا تركت الحقل فارغاً، سيتم إلغاء التأكيد بدون إضافة ملاحظة
                    </p>
                </div>
                
                <div className="flex gap-3 pt-4">
                    <button
                        onClick={() => setShowRemoveModal(false)}
                        className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                        إلغاء
                    </button>
                    <button
                        onClick={removeFromVisaList}
                        disabled={isLoading}
                        className="flex-1 px-4 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <RefreshCw size={16} />}
                        إلغاء التأكيد
                    </button>
                </div>
            </div>
        </div>
    </div>
)}


{showApplicationInfoModal && selectedPassport && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="bg-indigo-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-bold">📋 تحديث معلومات الطلب</h3>
                    <button
                        onClick={() => setShowApplicationInfoModal(false)}
                        className="text-white hover:bg-indigo-700 p-2 rounded-full"
                    >
                        <X size={20} />
                    </button>
                </div>
                <p className="text-indigo-100 mt-2">{selectedPassport.NameArabic}</p>
            </div>
            
            <div className="p-6 space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        رقم الطلب
                    </label>
                    <input
                        type="text"
                        value={applicationInfoForm.applicationNumber}
                        onChange={(e) => setApplicationInfoForm(prev => ({ 
                            ...prev, 
                            applicationNumber: e.target.value 
                        }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500"
                        placeholder="أدخل رقم الطلب..."
                    />
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        تاريخ البصمة
                    </label>
                    <input
                        type="date"
                        value={applicationInfoForm.fingerprintDate}
                        onChange={(e) => setApplicationInfoForm(prev => ({ 
                            ...prev, 
                            fingerprintDate: e.target.value 
                        }))}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-indigo-500"
                    />
                </div>
                
                <div className="flex gap-3 pt-4">
                    <button
                        onClick={() => setShowApplicationInfoModal(false)}
                        className="flex-1 px-4 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                        إلغاء
                    </button>
                    <button
                        onClick={updateApplicationInfo}
                        disabled={isLoading}
                        className="flex-1 px-4 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {isLoading ? <RefreshCw className="animate-spin" size={16} /> : <Save size={16} />}
                        حفظ التحديث
                    </button>
                </div>
            </div>
        </div>
    </div>
)}



{/* 🆕 نافذة البيانات الإضافية */}
{showAdditionalDataModal && selectedPassportForAdditionalData && (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white p-6 rounded-t-2xl">
                <div className="flex justify-between items-center">
                    <div>
                        <h3 className="text-xl font-bold">📋 البيانات التفصيلية</h3>
                        <p className="text-purple-100 mt-1">{selectedPassportForAdditionalData.NameArabic}</p>
                        <div className="flex items-center gap-4 text-purple-200 text-sm mt-2">
                            <span>ID: {selectedPassportForAdditionalData.PassportID}</span>
                            <span>|</span>
                            <span>الشركة: {selectedPassportForAdditionalData.CompanyName}</span>
                            <span>|</span>
                            <span>نسبة الاكتمال: {selectedPassportForAdditionalData.CompletionPercentage || 0}%</span>
                        </div>
                    </div>
                    <button
                        onClick={() => setShowAdditionalDataModal(false)}
                        className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-full transition-colors"
                    >
                        <X size={24} />
                    </button>
                </div>
                
                {/* شريط التقدم */}
                <div className="mt-4">
                    <div className="w-full bg-white bg-opacity-20 rounded-full h-2">
                        <div 
                            className="bg-white h-2 rounded-full transition-all duration-500" 
                            style={{ width: `${selectedPassportForAdditionalData.CompletionPercentage || 0}%` }}
                        ></div>
                    </div>
                    <div className="text-xs text-purple-100 mt-1">
                        {Math.round((selectedPassportForAdditionalData.CompletionPercentage || 0) / 25)} من 4 حقول مكتملة
                    </div>
                </div>
            </div>
            
            <div className="p-6">
                {/* معلومات سريعة */}
                <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-4 mb-6">
                    <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                        ℹ️ معلومات أساسية
                    </h4>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                            <span className="text-gray-600">المهنة الأساسية:</span>
                            <span className="font-medium text-gray-800 mr-2">{selectedPassportForAdditionalData.PassportProfessionName}</span>
                        </div>
                        <div>
                            <span className="text-gray-600">المندوب:</span>
                            <span className="font-medium text-gray-800 mr-2">{selectedPassportForAdditionalData.DelegateName}</span>
                        </div>
                        <div>
                            <span className="text-gray-600">الحالة النهائية:</span>
                            <span className={`font-medium mr-2 ${
                                selectedPassportForAdditionalData.FinalStatus === 'مكتمل' ? 'text-green-600' :
                                selectedPassportForAdditionalData.FinalStatus === 'جاري العمل' ? 'text-blue-600' :
                                'text-gray-600'
                            }`}>
                                {selectedPassportForAdditionalData.FinalStatus || 'في الانتظار'}
                            </span>
                        </div>
                        <div>
                            <span className="text-gray-600">حالة الدفع:</span>
                            <span className={`font-medium mr-2 ${
                                selectedPassportForAdditionalData.PaymentStatus === 'مدفوع' ? 'text-green-600' :
                                'text-red-600'
                            }`}>
                                {selectedPassportForAdditionalData.PaymentStatus || 'غير مدفوع'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* نموذج البيانات الإضافية */}
                <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* رقم التأشيرة */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                🎫 رقم التأشيرة
                                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                                    مطلوب
                                </span>
                            </label>
                            <input
                                type="text"
                                value={additionalDataForm.visaNumber}
                                onChange={(e) => setAdditionalDataForm(prev => ({ 
                                    ...prev, 
                                    visaNumber: e.target.value 
                                }))}
                                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                                placeholder="مثال: 1303938698"
                                maxLength={50}
                            />
                            <div className="text-xs text-gray-500 mt-1">
                                يُفضل أن يبدأ بحرف V متبوعاً بأرقام
                            </div>
                        </div>

                        {/* رقم صاحب العمل */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                                🏢 رقم صاحب العمل
                                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                                    مطلوب
                                </span>
                            </label>
                            <input
                                type="text"
                                value={additionalDataForm.employerNumber}
                                onChange={(e) => setAdditionalDataForm(prev => ({ 
                                    ...prev, 
                                    employerNumber: e.target.value 
                                }))}
                                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                                placeholder="مثال: 7012483983"
                                maxLength={50}
                            />
                            <div className="text-xs text-gray-500 mt-1">
                                رقم تسجيل صاحب العمل في وزارة العمل
                            </div>
                        </div>
                    </div>

                    {/* المهنة التفصيلية */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                            💼 المهنة بالتفصيل
                            <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                                اختياري
                            </span>
                        </label>
                        <textarea
                            value={additionalDataForm.detailedProfession}
                            onChange={(e) => setAdditionalDataForm(prev => ({ 
                                ...prev, 
                                detailedProfession: e.target.value 
                            }))}
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                            rows="3"
                            placeholder="مثال: مهندس برمجيات متخصص في تطوير تطبيقات الويب والهاتف المحمول، خبرة في React و Node.js"
                            maxLength={300}
                        />
                        <div className="text-xs text-gray-500 mt-1 flex justify-between">
                            <span>وصف مفصل للمهنة والتخصص</span>
                            <span>{additionalDataForm.detailedProfession.length}/300</span>
                        </div>
                    </div>

                    {/* اسم الشركة التفصيلي */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                            🏭 اسم الشركة بالتفصيل
                            <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                                اختياري
                            </span>
                        </label>
                        <textarea
                            value={additionalDataForm.detailedCompanyName}
                            onChange={(e) => setAdditionalDataForm(prev => ({ 
                                ...prev, 
                                detailedCompanyName: e.target.value 
                            }))}
                            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                            rows="3"
                            placeholder="مثال: شركة التقنية المتقدمة للبرمجيات والحلول الرقمية المحدودة - فرع الرياض"
                            maxLength={300}
                        />
                        <div className="text-xs text-gray-500 mt-1 flex justify-between">
                            <span>الاسم الكامل والرسمي للشركة</span>
                            <span>{additionalDataForm.detailedCompanyName.length}/300</span>
                        </div>
                    </div>

                    {/* معاينة البيانات */}
                    <div className="bg-gray-50 rounded-lg p-4">
                        <h5 className="font-medium text-gray-800 mb-3 flex items-center gap-2">
                            👁️ معاينة البيانات
                        </h5>
                        <div className="space-y-2 text-sm">
                            <div className="flex">
                                <span className="w-32 text-gray-600">رقم التأشيرة:</span>
                                <span className="font-medium text-gray-800">
                                    {additionalDataForm.visaNumber || 'غير محدد'}
                                </span>
                            </div>
                            <div className="flex">
                                <span className="w-32 text-gray-600">رقم صاحب العمل:</span>
                                <span className="font-medium text-gray-800">
                                    {additionalDataForm.employerNumber || 'غير محدد'}
                                </span>
                            </div>
                            <div className="flex">
                                <span className="w-32 text-gray-600">المهنة:</span>
                                <span className="font-medium text-gray-800">
                                    {additionalDataForm.detailedProfession || 'غير محدد'}
                                </span>
                            </div>
                            <div className="flex">
                                <span className="w-32 text-gray-600">الشركة:</span>
                                <span className="font-medium text-gray-800">
                                    {additionalDataForm.detailedCompanyName || 'غير محدد'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* أزرار الإجراءات */}
                <div className="flex gap-4 pt-6 border-t border-gray-200">
                    <button
                        onClick={() => setShowAdditionalDataModal(false)}
                        className="flex-1 px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
                    >
                        <X size={18} />
                        إلغاء
                    </button>
                    
                    <button
                        onClick={() => {
                            // مسح جميع الحقول
                            setAdditionalDataForm({
                                visaNumber: '',
                                employerNumber: '',
                                detailedProfession: '',
                                detailedCompanyName: ''
                            });
                        }}
                        className="px-6 py-3 border border-orange-300 rounded-lg text-orange-700 hover:bg-orange-50 transition-colors flex items-center justify-center gap-2"
                    >
                        <RefreshCw size={18} />
                        مسح الكل
                    </button>
                    
                    <button
                        onClick={saveAdditionalDataModal}
                        disabled={isLoading}
                        className="flex-1 px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:from-purple-700 hover:to-blue-700 disabled:opacity-50 transition-all duration-300 flex items-center justify-center gap-2"
                    >
                        {isLoading ? (
                            <>
                                <RefreshCw className="animate-spin" size={18} />
                                جاري الحفظ...
                            </>
                        ) : (
                            <>
                                <Save size={18} />
                                حفظ البيانات
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    </div>
)}




        </div>
    );
};

export default VisaNetRegistration;